import { useState, useEffect, useRef, useMemo, forwardRef, useImperativeHandle } from 'react';
import {
    Autocomplete, Box, Button, IconButton, Table, TableBody, TableCell, TableHead, TableRow, TextField,
    Tooltip, Typography, Select, MenuItem, Card, Divider,
    Modal, Stack, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions,
    Tab, Tabs, TableContainer, Paper, FormControl, InputLabel, Chip, ListItem, ListItemText,
    OutlinedInput
} from '@mui/material';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import { Colors } from '../../../../Styles/Colors';
import { CommonEditButton, CommonDeleteButton, DeletePopup, ConfirmPopup, HighAlertDrugPopup } from '../../../../Components/Common Components/CommonComponents';
import { renderTitle, renderIconButton } from "./SarasCommonComp";
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import ShowComponents from '../Common/ShowComponent';
import { localGetItem } from '../../../../Utility/Services/CacheProviderService';
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';
import { debounce, formatDate } from '../../../../Components/CommonFunctions/CommonFunctions';
import DeleteIcon from '@mui/icons-material/Delete';
import { Days, FoodUsage, Months, Prescription_Days, TabletQty, Weeks, Year, language } from '../../../../Utility/Constants';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTime } from 'luxon';
import ErrorIcon from '@mui/icons-material/Error';

const headers = ['Favourite', 'Prescription', 'M-A-E-N', 'Duration', 'Comments', 'Action'];
const Usage_Type = [
    { value: "ES", label: "Empty Stomach" },
    { value: "BF", label: "Before Food" },
    { value: "WF", label: "With Food" },
    { value: "AF", label: "After Food" },
    { value: "EU", label: "External Use" },
    { value: "SOS", label: "SOS" },
];
const durationOptions = {
    '1': 'Days',
    '2': 'Weeks',
    '3': 'Months',
    '4': 'Years',
    '5': 'Alternative Days'
};

const UNIT_LIST = ['mg', 'Drops', 'ml']

const Number_Count = ['1', '2', '3', '4', '5', '6', '7', '8', '9']
let showQty = false; 
let is_save_transmit = false;

const SarasPrescription = forwardRef(({ Title, PatientData, errorMessage, successMessage, ...props }, ref) => {
    const [state, setState] = useState({
        openPrescripton: false,
        openPrevious: false,
        tabValue: '1',
        disTapper: false,
        disPres: false,
        DisableBtn: false,
        externalDrug: false,
        FreqDrugList: [],
        selectedDrugId: null,
        clinicId: localGetItem('SelectedDoctorClinicId'),
        TapperDrugList: [],
        tabletQty: TabletQty,
        foodUsage: FoodUsage,
        appointmentId: PatientData?.appointment_id,
        patientId: PatientData?.patient_id,
        appointmentDate: PatientData?.appointment_date,
        isLocked: false,
        selectedLanguage: 'english',
        languageList: language,

        // whole prescription data
        prescriptionData: [],
        pharmacyList: [],
        selectedPharmacy: null,
        selectedDrug: '',
        searchedDrugList: [],
        searchedBrandName: '',
        searchedGenericName: null,
        genericList: [],
        dosageStrength: '',
        dosageType: '',
        morningQty: '0',
        afternoonQty: '0',
        eveningQty: '0',
        nightQty: '0',
        selectedUsage: '',
        selectedDays: '1',
        selectedDuration: '',
        durationDays: Days,
        durationWeeks: Weeks,
        durationMonts: Months,
        durationYears: Year,
        prescriptionList: [],
        comments: '',
        favourite: false,
        selectedDrugId: null,
        prescriptionId: null,
        removeData: false,
        selectedId: null,
        isEdit: false,
        selectedIndex: null,
        ExternalDrugAdd: false,

        EditIndex: null,
        AddClicked: false,
        FrequencyText: "",
        DrugSuggestionList: [],
        AllowEdit: false,
        ExternalDrugName: "",
        ExternalGenericName: "",
        ExternalDosageStrength: "",
        ExternalDosageType: "",
        checkMl: false,
        ExternalDrugList: [],
        ExternalBrandName: '',
        drugSearchFor: 1,
        prescUsage: null,
        prescriptionUsage: [],
        openAddNew: false,
        usagseId: null,
        prescripTblData: [],
        value: 'one',
        stock_in_quantity: 0,
        prescDosageFormList: [],
        openAddNewDosForm: false,
        selectedDosageForm: 'Tablet',
        prescDosageForm: null,
        postFormLoad: false,
        presc_quantity: '',
        from_frequency: false,

        // tapper Med state
        tapperList: [],
        tapMedListData: [],
        newTapMedListData: [],
        newTapSearchDrug: null,
        newTapMedDate: new Date(),
        newTapMedOpenDate: false,
        newTapMedDrugListData: [],
        newTapMedDuration: '',
        newTapDurationType: 'Day(s)',
        newTapMedUnit: "",
        newTapMedUnitType: '',
        newTapMedFrequency: '',
        newTapMedReduceBy: '',
        newTapMedFreqTablet: null,
        newTapMedQty: '',
        newTapMedUsage: '',
        newTapMedComments: '',
        newTapMedGenList: {},
        isNewTapEdit: false,
        newTapMedSelectedIndex: null,
        leftSelectedIndex: null,
        dupTapMedDetails: '{}',
        newLftTapEdit: false,
        newTapMedId: null,
        newTapMedIsFav: false,
        isChange: false,
        tapUsage: '',
        tapMorning: '',
        tapAfternoon: '',
        tapEvening: '',
        tapNight: '',
        selMor: false,
        selAft: false,
        selEve: false,
        selNig: false,
        selectedTabCount: '',
        TapperDrugList: [],
        tapSelectedId: null,
        MedicationFav: [],
        tapSelectedDrug: '',
        selectedDrugIdTap: null,
        checkOthers: false,
        // External Tapper Med
        tapperExternal: false,
        newTapExeSearchDrug: null,
        newTapMedExeDrugList: [],
        newTapMedExeDosageStrength: '',
        newTapMedExeDosageType: '',
        newTapMedExeGenericName: '',
        tempSearch: '',
        ExternalIsFav: false,
        newTapMedExeFav: false,
        is_pharmacy: false,
        newTapMedExeUnitType: 'mg',
        genericSuggList: [],
        dupExternalDrugList: [],
        frequency_list: [],

        // common edit state 
        isCommonEdit: false,
        commonEditIdx: null,

        // common table state
        isDeleteCliked: false,
        SelectedList: {},
        prevPrescripData: [],
        previousPrescripDate: [],
        prescriptionFav: [],
        prescriptionTemplateList: [],
        dupliPrescriptionData: "[]",
        selectedTemplate: null,
        SelectedEditIndex: null,
        languageList: language,
        selectedLanguage: 'english',
        Recalled: false,
        recallPopup: false,
        is_pharmacy: false,
        successPopup: false,
        successPopupTxt: '',
        smsSuccessTxt: '',
        isEditDuration: false,
        deleteTemplateName: null,
        deletePopup: false,
        removeData: false,
        selectedPrescripFav: [],
        prevAppointmentId: null,
        openPopupAddNew: false,
        transmitted: false,
        match_generic_list: [],
        fromCopyPrev: false,
        fromFav: false,
        match_generic_list: [],
        hasAllergy: false,
        addPath: '',
        dupPrescriptionData: [],
        dupSelectedPharmacy: null,
        dupUpdateArray: [],

         //Dropdown in Medication
        Selected_days:[],
        FetchedAIMedication: [],
        From_ai : false,
        recallReason: '',
        recallError: '',

        fo_external_drug_id: null,
        selectedDrug: '',
        is_high_alert: false,
        is_look_alike: false,
        is_sound_alike: false,
        highAlert: false,
        lookAlikeDrugs: [],
        SoundAlikeDrugs: [],
        skipHighAlertCheck: false,
        forceRefreshDrug: false,
        enable_drug_alert: false,
        FavDrugData: false
    })
    const [allergyPopup, setAllergyPopup] = useState(false)
    const [isLoader, setIsLoader] = useState(false)
    const [allergyProcced, setAllergyProcced] = useState(false)

    const dobounceApiSearch = useRef(debounce((brandName, genericName, brandNameSelected = false) => {
        getExternalDrugSearchList(brandName, genericName, brandNameSelected = false);
    }, 300));

    const previousRequestRef = useRef({});

    const updateState = (updates) => {
        setState((prev) => ({ ...prev, ...updates }));
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            try {
                if (props?.isSelected && e.ctrlKey && e.shiftKey && e.key.toLowerCase() === 'g') {
                    e.preventDefault();
                    updateState({ openPopupAddNew: true, tempType: 'Add' })
                }
            } catch (err) {
                console.error('KeyDown failed:', err);
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [props?.isSelected]);

    useEffect(() => {
        const hasPharmacy = JSON.parse(localGetItem('loggedInUserInfo'))?.pharmacy_data;
        const isPharma = hasPharmacy?.length === 0;
        const drugSearch = localGetItem('drug_search') !== 'undefined' ? JSON.parse(localGetItem('drug_search')) : 1;
        const enable_drug_alert = localGetItem('enable_drug_alert') ? JSON.parse(localGetItem('enable_drug_alert')) : false;
        showQty = localGetItem('show_quantity_in_prescription') === 'true' ? true : false;
        is_save_transmit = localGetItem('prescription_save_transmit') === 'true' ? true : false;
        
        updateState({
            is_pharmacy: isPharma,
            externalDrug: isPharma,
            tapperExternal: isPharma,
            drugSearchFor: drugSearch,
            clinicId: localGetItem('SelectedDoctorClinicId') || null,
            enable_drug_alert: enable_drug_alert
        })
    }, [])

    useEffect(() => {
        if(state.tabValue == "1"){
            ClearData()
        }
        else{
            onClearTapMedHandler()
        }
    // },[state.tapperExternal, state.ExternalDrugAdd])
    },[state.tapperExternal])

    useEffect(() => {
        if(state?.openFav){
            getPrescriptionFavouriteData()
        }
    },[state.openFav])
    

    // useEffect(() => {
    //     if (allergyProcced) {
    //         if (state.addPath == "prescription") {
    //             addPrescriptionData()
    //         } else if (state.addPath == "tapperMed") {
    //             addTapperMedData()
    //         } else if (state.addPath === 'favorite') {
    //             updateState({ selectedPrescripFav: dupData })
    //         }
    //         setAllergyProcced(false);
    //     }
    // }, [allergyProcced])

    useEffect(() => {
        if (state.newTapMedExeUnitType === 'mg') {
            onClearTapMedHandler(false, true);
        }
    }, [state.newTapMedExeUnitType]);

    useEffect(() => {
        if (state.selectedDrugIdTap !== null) {
            getGenericNameList();
        }
    }, [state.selectedDrugIdTap]);

    useEffect(() => {
        if (!state.openPrescripton) {
            ClearData()
            onClearTapMedHandler()
        }
    }, [state.openPrescripton])

    useEffect(() => {
        if (props?.FetchedAIMedication?.length > 0) {
            let AiMedicationList = []
            props?.FetchedAIMedication?.forEach((item)=>{
                let obj = {}
                if (item?.drug_ms_id) {
                    obj = {
                        ...item,
                        is_tapper_meds: false,
                        tapper_meds: [],
                        from_ai: true,
                        drug_name: item?.brand_name,
                        is_favorite: false,
                        id : null
                    }
                } else {
                    obj = {
                        ...item,
                        is_tapper_meds: false,
                        tapper_meds: [],
                        is_external_drug: true,
                        from_ai: true,
                        drug_name: item?.brand_name,
                        is_favorite: false,
                        id : null
                    }
                }
                AiMedicationList.push(obj)
            })

            updateState({
                openPrescripton : true,
                prescriptionList: [...state?.prescriptionList?.filter((item)=>(!item?.from_ai)), ...AiMedicationList]
            })
            getPharmacyList()
            getPrescriptionFavouriteData();
            getPresctiptionUsageList();
            getPresDosageFormList();
            props.clearFetchedAIMedication()
        }
    }, [props?.FetchedAIMedication])

    useEffect(() => {
        if (state.newTapExeSearchDrug) {
            getExternalDrugSearchList((state.newTapExeSearchDrug?.drug_name ? state.newTapExeSearchDrug?.drug_name : state.newTapExeSearchDrug), '', true)
        } else {
            onClearTapMedHandler()
        }
    }, [state.newTapExeSearchDrug])

    useEffect(() => {
        const selectedDrug = state.selectedDrug;
        const searchedGenericName = state.searchedGenericName;
        const newTapSearchDrug = state.newTapSearchDrug;

        if (!selectedDrug && !searchedGenericName && !newTapSearchDrug) return;
        
        const currentKey = JSON.stringify({ selectedDrug, searchedGenericName, newTapSearchDrug });
        // Avoid duplicate API calls for the same combination
        if (
            (selectedDrug || searchedGenericName || newTapSearchDrug) &&
            previousRequestRef.current !== currentKey || state.forceRefreshDrug
        ) {
            previousRequestRef.current = currentKey;
            updateState({
                skipHighAlertCheck : false,
                forceRefreshDrug: false
            })
            getGenericNameList(state.from_frequency ? true : false, state.isCommonEdit || state.isEdit);
        }
    }, [state.selectedDrug, state.searchedGenericName, state.newTapSearchDrug, state.isCommonEdit, state.isEdit, state.from_frequency]);

    // useeffect of transmit, prev prescription, favourite
    useEffect(() => {
        if (state.isTransClked && state.selectedPharmacy) {
            postPrescriptionTransmit()
        }
    }, [state.isTransClked, state.selectedPharmacy])

    useEffect(() => {
        if (state.openPrescripton && state.selectedPharmacy) {
            getFreqDrugList()
        }
    }, [state.openPrescripton, state.selectedPharmacy])

    useEffect(() => {
        props.handleDisableTransfer(state.transmitted)
    }, [state.transmitted]);

    useEffect(() => {
        if (state.selectedTemplate) {
            const data = state.selectedTemplate?.medication?.map((item) => ({
                ...item,
                prescription_id: null,
                id: null,
                dosage_unit: item?.is_unit_ml ? "ML" : item?.is_unit_others ? "Others" : item?.dos_unit ?? "Tablet",
                quantity: item.quantity ? item.quantity : calcDuration(item.duration_mode, item.duration, item) || 0,
            }));
            const Array = [...state.prescriptionData || [], ...data];

            if (state.selectedTemplate?.match_generic_list?.length > 0) {
                updateState({ addPath: 'template', dupPrescriptionData: Array })
                setAllergyPopup(true)
            } else {
                PostPrescriptionData(Array)
            }
        }
    }, [state.selectedTemplate])

    const hasFetched = useRef(false);

    useEffect(() => {
        if (hasFetched.current) return;

        const pharmacyId = state.prescriptionData?.[0]?.pharmacy_id || state.selectedPharmacy;

        if (pharmacyId) {
            getPrescriptionListData(pharmacyId);
            hasFetched.current = true;
        }
    }, [state.prescriptionData, state.selectedPharmacy]);

    useEffect(() => {
        if(state.tabValue == "1"){
            onClearTapMedHandler()
        }
        else{
            ClearData()
        }
    },[state.tabValue])

    useEffect(() => {
        if (state.selectedDays && state.selectedDuration) {
            calcDuration(state.selectedDays, state.selectedDuration)
        }
    }, [state.selectedDays, state.selectedDuration, state.morningQty,
    state.afternoonQty, state.eveningQty, state.nightQty])

    const getApiCall = async () => {
        const { defaultPharmacy } = await getPharmacyList();
        await getPrescriptionData(defaultPharmacy);
        getPrescriptionFavouriteData();
        getPresctiptionUsageList();
        getPresDosageFormList();
    };

     //handle for dropdown 
  const handleChange = (event) =>{
    const {
      target: {value},
    } = event;
    // setMedication({
    //   ...Medication
    //  Selected_days: typeof value === 'string' ? value.split(',') : value,
    // })
    setState((prev) =>({
       ...prev,
      Selected_days: typeof value === 'string' ? value.split(',') : value,
    }))
  }


  const convertDayToNumber = (day) => {
    switch (day) {
      case "Sunday":
        return 0;
      case "Monday":
        return 1;
      case "Tuesday":
        return 2;
      case "Wednesday":
        return 3;
      case "Thursday":
        return 4;
      case "Friday":
        return 5;
      case "Saturday":
        return 6;
      default:
        return null;
    }
  };

  const convertNumberToDay = (number) => {
  switch (number) {
    case 0:
      return "Sunday";
    case 1:
      return "Monday";
    case 2:
      return "Tuesday";
    case 3:
      return "Wednesday";
    case 4:
      return "Thursday";
    case 5:
      return "Friday";
    case 6:
      return "Saturday";
    default:
      return null;
  }
};


    const getPrescriptionData = async (defaultPharmacy) => {
        const { appointmentId } = props;
        try {
            const response = await RestAPIService.getAll(
                Serviceurls.SARAS_DOC_PRESCRIPTION_DATA + `?appointment_id=${appointmentId}`
            );

            if (response.data.status === "success") {
                const data = response.data.data?.length > 0 ? response.data.data : [];
                const list = data[0]?.medication || [];

                const tapperData = [];
                const nonTapperData = [];

                list.forEach((item) => {
                    item["dosage_unit"] = item.dos_unit ?? "Tablet";
                    delete item.dos_unit;
                    if (!item.quantity && item.quantity !== 0) {
                        item.quantity = calcDuration(item.duration_mode ?? "1", item.duration ?? 0, item) || 0;
                    }
                    if (item.tapper_meds?.length > 0) {
                        tapperData.push(item);
                    } else {
                        nonTapperData.push(item);
                    }
                });

                updateState({
                    prescriptionData: list,
                    selectedPharmacy: data[0]?.pharmacy_id ?? state.selectedPharmacy ?? defaultPharmacy,
                    prescriptionId: data[0]?.id || null,
                    Recalled: data[0]?.is_billed || false,
                    transmitted: list[0]?.is_transmitted || false,
                    prescriptionList: nonTapperData,
                    tapperList: tapperData,
                });
            } else {
                errorMessage(response.data.message);
            }
        } catch (error) {
            errorMessage(error?.response?.data?.message || error.message);
        }
    };

    const getPharmacyList = async () => {
        try {
            const userInfo = JSON.parse(localGetItem("loggedInUserInfo")) || {};
            const pharmacyList = userInfo.pharmacy_data || [];
            const defaultPharmacy = pharmacyList[0]?.pharmacy_id ?? null;

            updateState({
                pharmacyList,
                selectedPharmacy: defaultPharmacy,
            });

            return { pharmacyList, defaultPharmacy };
        } catch (error) {
            errorMessage(error.message);
            return { pharmacyList: [], defaultPharmacy: null };
        }
    };

    const getExternalDrugSearchList = (brandName, genericName, brandNameSelected = false) => {
        try {
            let params = `?brand_name=${brandName}&generic_name=${genericName}`;
            if (state.tabValue === '2') {
                params += `&is_tapper_med=true`;
            }
            RestAPIService.getAll(Serviceurls.DOC_OPT_EXTERNAL_DRUG + params)
                .then((response) => {
                    if (response.data.status === 'success') {
                        if (state.tabValue === '1') {
                            const Data = response?.data?.data ? response?.data?.data : [];
                            const uniqueDrugsObj = Data.reduce((acc, drug) => {
                                const key = drug?.drug_name?.trim().toUpperCase(); // Normalize drug_name

                                if (!acc[key]) {
                                    acc[key] = {
                                        drug_name: drug.drug_name,
                                        generic_name: [
                                            {
                                                generic_name: drug?.generic_name,
                                                dosage_type: drug?.dosage_type,
                                                dosage_strength: drug?.dosage_strength,
                                                is_favorite: drug?.is_favorite,
                                                latest_prescription: drug?.latest_prescription,
                                                fo_external_drug_id: drug?.fo_external_drug_id || null,
                                            }
                                        ]
                                    };
                                } else {
                                    const existingGeneric = acc[key].generic_name?.find(
                                        (g) => g.generic_name === drug.generic_name &&
                                            g.dosage_type === drug.dosage_type &&
                                            g.dosage_strength === drug.dosage_strength
                                    );

                                    if (!existingGeneric) {
                                        acc[key].generic_name.push({
                                            generic_name: drug.generic_name,
                                            dosage_type: drug.dosage_type,
                                            dosage_strength: drug?.dosage_strength,
                                            is_favorite: drug?.is_favorite,
                                            latest_prescription: drug?.latest_prescription,
                                        });
                                    }
                                }
                                return acc;
                            }, {});

                            const uniqueDrugsArray = Object.values(uniqueDrugsObj);
                            const genericSuggList = uniqueDrugsArray?.find((item) => item?.drug_name === state.externalBrandName)

                            updateState({
                                dupExternalDrugList: Data,
                                ExternalDrugList: uniqueDrugsArray,
                                genericSuggList: (state.isEdit && genericSuggList) ? genericSuggList?.generic_name : []
                            });
                        } else {
                            let unit = response.data.data[0]?.dosage_strength ? response.data.data[0]?.dosage_strength?.match(/\d+/) : response.data.data[0]?.dosage_strength
                            updateState({
                                newTapMedExeDrugList: response?.data?.data,
                                // newTapMedExeDosageStrength: brandNameSelected ? response?.data?.data[0]?.dosage_strength : '',
                                // newTapMedExeDosageType: brandNameSelected ? response?.data?.data[0]?.dosage_type : '',
                                // newTapMedExeGenericName: brandNameSelected ? response?.data?.data[0]?.generic_name : '',
                                // newTapMedExeFav: brandNameSelected ? response?.data?.data[0]?.is_favorite : false,
                                // newTapMedUnitType: 'Mg',
                                // newTapMedUnit: brandNameSelected ? unit : ''
                            })
                        }
                    }
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    // dosage form apis start
    const getPresDosageFormList = () => {
        try {
            RestAPIService.getAll(Serviceurls.DOC_PRESCRIPTION_DOSAGEFORM_LIST)
                .then((response) => {
                    if (response.data.status === 'success') {
                        updateState({ prescDosageFormList: response.data.data })
                    }
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const postPresDosageFormList = () => {
        try {
            updateState({ postFormLoad: true })
            const data = {
                "dosage_unit": state.prescDosageForm?.trim()
            }
            if ( !state.prescDosageForm?.trim() ) {
                updateState({ postFormLoad: false })
                errorMessage('Please Enter Usage')
            } else {
                RestAPIService.create(data, Serviceurls.DOC_PRESCRIPTION_DOSAGEFORM_LIST)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            successMessage(response.data.message)
                            updateState({
                                selectedDosageForm: state.prescDosageForm,
                                morningQty: '0',
                                afternoonQty: '0',
                                eveningQty: '0',
                                nightQty: '0',
                                checkMl: false,
                                checkOthers: false,
                                openAddNewDosForm: false,
                                postFormLoad: false,
                                prescDosageForm: null
                            })
                            getPresDosageFormList()
                        }
                    }).catch((error) => {
                        updateState({ postFormLoad: false })
                        errorMessage(error?.response?.data?.message || error.message)
                    })
            }
        } catch (error) {
            updateState({ postFormLoad: false })
            errorMessage(error.message)
        }
    }

    const deleteDosageFormList = (item) => {
        try {
            RestAPIService.delete(Serviceurls.DOC_PRESCRIPTION_DOSAGEFORM_LIST + '?id=' + item?.id, {})
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        getPresDosageFormList()
                    }
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }
      // dosage form apis end

    const PostPrescriptionData = (data = []) => {
        const { appointmentId } = props;
        try {
            const Data = (
                Array.isArray(data) && data.length > 0
                    ? data
                    : [...(state.prescriptionList || []), ...(state.tapperList || [])]
            ).map(item => ({
                ...item,
                id: item?.id ?? null,
                frequency: item?.frequency ?? ""
            }));

            const datas = {
                "appointment_id": appointmentId,
                "prescription_id": Data[0]?.prescription_id || state.prescriptionId || null,
                "medication": Data,
                "clinic_id": +state.clinicId,
            };
            const prescriptionData = Data?.filter(item => item.tapper_meds?.length === 0);
            const FinalCheck = state.tabValue === '1' ? checkFinalValidation(prescriptionData) : null;
            if(FinalCheck){
                errorMessage(FinalCheck);
            }
            if (Data?.some((item, i) => !item?.duration)) {
                errorMessage("Select Duration")
            } else if(FinalCheck === null) {
                RestAPIService.create(datas, Serviceurls.SARAS_DOC_PRESCRIPTION_DATA)
                    .then((response) => {
                        if (response?.data?.status === 'success') {
                            successMessage(response?.data?.message)
                            updateState({
                                prescriptionList: [],
                                tapperList: []
                            })
                            closePrescPopup()
                            getPrescriptionData();
                            getPrescriptionFavouriteData();
                            if(is_save_transmit && data?.length === 0){
                                postPrescriptionTransmit();
                            }
                        }
                    }).catch((error) => {
                        errorMessage(error?.response?.data?.message || error.message)
                    })
            }
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const postPrescriptionTransmit = (recalled = false) => {
        try {
            const data = {
                appointment_id: PatientData?.appointment_id,
                prescription_id: state.prescriptionData[0]?.prescription_id || state.prescriptionId,
                pharmacy_id: state.selectedPharmacy,
                is_recall: recalled,
                recalled_reason: state.recallReason,
                time: new Date().toISOString(),
            };
            RestAPIService.create(data, Serviceurls.SARAS_DOC_PRESCRIPTION_TRANSMIT)
                .then((response) => {
                    if (response.data.status === 'success') {
                        let smsConfig = localGetItem("smsConfig") ? JSON.parse(localGetItem("smsConfig")) : {}
                        if (!recalled && smsConfig?.prescription_sms) {
                            updateState({
                                isEditDuration: false,
                                successPopup: true,
                                successPopupTxt: response.data.message,
                                smsSuccessTxt: response.data.sms_message,
                                recallReason: '',
                                recallError: ''
                            })
                        } else {
                            updateState({ isEditDuration: false })
                            successMessage(response.data.message)
                        }
                        updateState({
                            transmitted: !recalled,
                            recallPopup: false,
                            isTransClked: false,
                        })
                        getPrescriptionData()
                    }
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const handleTransmit = () => {
        let LoggedData = localGetItem("loggedInUserInfo") ? JSON.parse(localGetItem("loggedInUserInfo")) : null;
        let pharmaList = LoggedData?.pharmacy_data ? JSON.parse(JSON.stringify(LoggedData?.pharmacy_data)) : [];
        updateState({
            isTransClked: true,
            selectedPharmacy: state.prescriptionData[0]?.pharmacy_id ? state.prescriptionData[0]?.pharmacy_id : (pharmaList?.length ? pharmaList[0]?.pharmacy_id : "")
        })
    };

    const getPrescriptionPrint = (prevAppointmentId = null) => {
        try {
            RestAPIService.getAllTwo(Serviceurls.SARAS_DOC_PRESCRIPTION_DATA + `?language=${state.selectedLanguage}&appointment_id=${prevAppointmentId || PatientData?.appointment_id || ""}&export_type=pdf`)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    // previous prescription popup start

    const getPreviousPrescriptionData = () => {
        try {
            RestAPIService.getAll(Serviceurls.SARAS_DOC_PREV_PRESCRIPTION + `?patient_id=${PatientData?.patient_id}&appointment_id=${PatientData?.appointment_id}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        const Data = response?.data?.data?.length > 0 ? response.data.data : [];
                        updateState({
                            openPrevious: true,
                            previousPrescripDate: Data,
                            selectedPrevDate: Data[0]?.date,
                            prevPrescripData: Data[0]?.medication || [],
                            prevAppointmentId: Data[0]?.appointment_id || null,
                            match_generic_list: Data[0]?.match_generic_list || [],
                        })
                    }
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }
    const copyPreviousPrescription = () => {
        try {
            const creatArr = state.prevPrescripData?.map((item) => ({
                ...item,
                prescription_id: null,
                id: null,
                dosage_unit: item?.is_unit_ml ? "ML" : item?.is_unit_others ? "Others" : item?.dos_unit ?? "Tablet",
                quantity: item.quantity ? item.quantity : calcDuration(item.duration_mode, item.duration, item) || 0,
            }));
            const Array = [...(state.prescriptionData || []), ...(creatArr || [])]
            PostPrescriptionData(Array)
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderPreviousPrescriptionPopup = () => {
        try {
            state.prevPrescripData?.forEach((element, index) => element.sno = index + 1)
            return (
                <Box component={'div'}>
                    <Modal open={state.openPrevious}>
                        <Box component={'div'} className='eMed_Doc_Notes_Counsellor_Pop_Up'>
                            <Box component={'div'} display={'flex'} justifyContent={'space-between'} mt={'0.5vw'}>
                                <Typography pl={'0.5vw'} fontWeight={600} color={Colors.SecondaryText}>Previous Prescription</Typography>
                                <Button
                                    onClick={() => { updateState({ openPrevious: false }) }}
                                >
                                    <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1.1vw'} width={'1.1vw'} />
                                </Button>
                            </Box>
                            <Box component={'div'} display={'flex'} m={'0.5vw'} alignItems={'center'}>
                                <Autocomplete
                                    size='small'
                                    clearIcon
                                    sx={{ width: '15vw', mr: '1vw' }}
                                    options={state.previousPrescripDate}
                                    getOptionLabel={(option) => typeof (option) === 'string' ? formatDate(option) : formatDate(option?.date)}
                                    value={state.selectedPrevDate}
                                    onChange={(e, value) => {
                                        updateState({
                                            selectedPrevDate: value?.date,
                                            prevPrescripData: value?.medication || [],
                                            prevAppointmentId: value?.appointment_id,
                                            match_generic_list: value?.match_generic_list || []
                                        })
                                    }}
                                    renderInput={(params) => <TextField {...params} label={'Select Date'} />}
                                />
                                <Button variant='contained'
                                    sx={{ textTransform: 'capitalize', mr: '1vw' }}
                                    onClick={() => getPrescriptionPrint(state.prevAppointmentId || null)}
                                    disabled={state.previousPrescripDate?.length > 0 ? false : true}
                                >Print</Button>
                                <Button variant='contained'
                                    sx={{ textTransform: 'capitalize' }}
                                    onClick={() => {
                                        if (state.match_generic_list?.length > 0) {
                                            updateState({ addPath: 'copy', hasAllergy: true})
                                            setAllergyPopup(true)
                                        } else {
                                            copyPreviousPrescription()
                                        }
                                    }}
                                    disabled={state.isLocked || props.isLocked || (state.previousPrescripDate?.length > 0 ? false : true)}
                                >Copy</Button>
                            </Box>
                            <Box component={'div'} sx={{ height: '21vw', m: "0.5vw", overflow: 'auto', border: '1px solid lightgray' }}>
                                <Table size='small' stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ backgroundColor: Colors.Background, fontSize: '0.9dvw', fontWeight: 600 }}>Brand Name</TableCell>
                                            <TableCell sx={{ backgroundColor: Colors.Background, fontSize: '0.9dvw', fontWeight: 600 }}>M-A-E-N</TableCell>
                                            <TableCell sx={{ backgroundColor: Colors.Background, fontSize: '0.9dvw', fontWeight: 600 }}>Usage</TableCell>
                                            <TableCell sx={{ backgroundColor: Colors.Background, fontSize: '0.9dvw', fontWeight: 600 }}>Description</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {state.prevPrescripData?.length > 0 ? state.prevPrescripData?.map((item, index) => {
                                            const showMl = (item?.is_unit_ml || item?.dosage_unit === "ML"|| item?.dos_unit === "ML") ? "ML" : "";
                                            return (
                                                <TableRow key={index}>
                                                    {item?.drug_name ? <TableCell>{item?.drug_name ?
                                                        <Box component={'div'}>
                                                            <Typography fontSize={'0.9vw'} fontWeight={600}>
                                                                {item?.drug_name?.length > 15 ? (
                                                                    <Tooltip placement='top' title={item?.drug_name}>
                                                                        <div>{item?.drug_name?.slice(0, 15) + '...'}</div>
                                                                    </Tooltip>
                                                                ) : (
                                                                    item?.drug_name
                                                                )}
                                                            </Typography>
                                                            <Typography display={"inline-flex"} fontSize={'0.8vw'} color={Colors.SecondaryText}>
                                                                {item?.generic_name ? (
                                                                    item.generic_name.length > 15 ? (
                                                                        <Tooltip placement='top' title={item.generic_name}>
                                                                            <div>{item.generic_name.slice(0, 15) + '...'}</div>
                                                                        </Tooltip>
                                                                    ) : (
                                                                        item.generic_name
                                                                    )
                                                                ) : (
                                                                    '-'
                                                                )} | {item?.drug_strength ? item.drug_strength : '-'} {item?.drug_type || ''}
                                                            </Typography>
                                                        </Box> : '-'
                                                    }</TableCell> :
                                                        <TableCell>{item?.doctor_drug_name ?
                                                            <Box component={'div'}>
                                                                <Typography fontSize={'0.9vw'} fontWeight={600}>
                                                                    {item?.doctor_drug_name?.length > 15 ? (
                                                                        <Tooltip placement='top' title={item?.doctor_drug_name}>
                                                                            <div>{item?.doctor_drug_name?.slice(0, 15) + '...'}</div>
                                                                        </Tooltip>
                                                                    ) : (
                                                                        item?.doctor_drug_name
                                                                    )}
                                                                </Typography>
                                                                <Typography display={"inline-flex"} fontSize={'0.8vw'} color={Colors.SecondaryText}>
                                                                    {item?.doctor_generic_name ? (
                                                                        item.doctor_generic_name.length > 15 ? (
                                                                            <Tooltip placement='top' title={item.doctor_generic_name}>
                                                                                <div>{item.doctor_generic_name.slice(0, 15) + '...'}</div>
                                                                            </Tooltip>
                                                                        ) : (
                                                                            item.doctor_generic_name
                                                                        )
                                                                    ) : (
                                                                        '-'
                                                                    )} | {item?.doctor_drug_strength ? item.doctor_drug_strength : '-'} {item?.doctor_dosagetype || ''}
                                                                </Typography>
                                                            </Box> : '-'
                                                        }</TableCell>}
                                                    {item?.tapper_meds?.length > 0 ? null :
                                                        <><TableCell>
                                                            <Box component={'div'}>
                                                                <Typography fontSize={showMl ? '0.8vw' : '0.9vw'} fontWeight={600}>{`${item?.morning ? item?.morning : '0'}${showMl} - ${item?.afternoon ? item?.afternoon : '0'}${showMl} - ${item?.evening ? item?.evening : '0'}${showMl} - ${item?.night ? item?.night : '0'}${showMl}`}</Typography>
                                                                <Typography fontSize={'0.8vw'} color={Colors.SecondaryText}>{instructions(item?.instructions)}</Typography>
                                                            </Box>
                                                        </TableCell>
                                                            <TableCell sx={{ fontSize: '0.9vw', fontWeight: 600 }}>{`${item?.duration} ${durationOptions[item?.duration_mode]}`}</TableCell>
                                                            <TableCell sx={{ fontSize: '0.9vw', fontWeight: 600 }}>{item?.comments ? item?.comments?.length > 10 ?
                                                                <Tooltip placement='top' title={item?.comments}><div>{item?.comments?.slice(0, 10) + '...'}</div></Tooltip> :
                                                                item?.comments : '-'}</TableCell></>}


                                                    {item?.tapper_meds?.length > 0 ?
                                                        <TableCell>
                                                            {item?.tapper_meds?.map((tapList, tapIndex) => {
                                                                let date = formatDate(tapList?.start_date) + "-" + formatDate(tapList?.end_date)
                                                                let mean = tapList?.morning + " - " + tapList?.afternoon + " - " + tapList?.evening + " - " + tapList?.night
                                                                return (
                                                                    <Box component={'div'} key={tapIndex} mb={'0.2dvw'}>
                                                                        {mean?.length > 20 ?
                                                                            <Tooltip placement='top' title={mean}><Typography fontSize={'0.8dvw'} fontWeight={600}>{mean?.slice(0, 20) + '...'}</Typography></Tooltip> :
                                                                            <Typography fontSize={'0.8dvw'} fontWeight={600}>{`${tapList?.morning ? tapList?.morning : '0'} - ${tapList?.afternoon ? tapList?.afternoon : '0'} - ${tapList?.evening ? tapList?.evening : '0'} - ${tapList?.night ? tapList?.night : '0'}`}</Typography>}
                                                                        <Typography fontSize={'0.8dvw'}>{instructions(tapList?.instructions)}</Typography>
                                                                        {date?.length > 22 ?
                                                                            <Tooltip placement='top' title={mean}><Typography fontSize={'0.8dvw'} fontWeight={600}>{date?.slice(0, 18) + '...'}</Typography></Tooltip> :
                                                                            <Typography fontSize={'0.8dvw'}>{`${tapList?.start_date ? formatDate(tapList?.start_date) : '-'} - ${tapList?.end_date ? formatDate(tapList?.end_date) : '-'}`}</Typography>
                                                                        }
                                                                    </Box>
                                                                )
                                                            })}
                                                        </TableCell> : null}
                                                    {item?.tapper_meds?.length > 0 ?
                                                        <TableCell>
                                                            {item?.tapper_meds?.map((tapList, tapIndex) => {
                                                                return (
                                                                    <Box component={'div'} key={tapIndex} mb={'0.2dvw'}>
                                                                        <Typography fontSize={'0.8dvw'} visibility={'hidden'}>{'kjsiudok55'}</Typography>
                                                                        <Typography fontSize={'0.8dvw'} fontWeight={600}>{`${tapList?.duration ? tapList?.duration : '-'}`}</Typography>
                                                                        <Typography fontSize={'0.8dvw'}>{`${tapList?.no_of_dosage ? tapList?.no_of_dosage : '-'}`}</Typography>
                                                                    </Box>
                                                                )
                                                            })}
                                                        </TableCell> : null}
                                                    {item?.tapper_meds?.length > 0 ?
                                                        <TableCell>
                                                            {item?.tapper_meds?.map((tapList, tapIndex) => {
                                                                return (
                                                                    <Box component={'div'} key={tapIndex} mb={'0.2dvw'}>
                                                                        <Typography fontSize={'0.8dvw'} visibility={'hidden'}>{'kjsiud55'}</Typography>
                                                                        <Typography fontSize={'0.8dvw'} visibility={'hidden'}>{'kjsiudoki'}</Typography>
                                                                        {tapList?.comments ? tapList?.comments?.length > 10 ?
                                                                            <Tooltip placement='top' title={tapList?.comments}><Typography fontSize={'0.8dvw'} fontWeight={600}>{tapList?.comments?.slice(0, 10) + '...'}</Typography></Tooltip> :
                                                                            <Typography fontSize={'0.8dvw'} fontWeight={600}>{tapList?.comments}</Typography> : '-'}
                                                                    </Box>
                                                                )
                                                            })}
                                                        </TableCell> : null}
                                                </TableRow>
                                            )
                                        }) :
                                            <TableRow><TableCell align='center' colSpan={4}>No Records To Be Shown</TableCell></TableRow>}
                                    </TableBody>
                                </Table>
                            </Box>
                        </Box>
                    </Modal>
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }
    // previous prescription popup end

    // template popup start
    const getPrescriptionListData = (pharmacyId) => {
        try {
            let pharmaId = pharmacyId || state.prescriptionData?.[0]?.pharmacy_id || state.selectedPharmacy
            RestAPIService.getAllTwo(Serviceurls.SARAS_DOC_PRESCRIPTION_TEMPLATE + '?patient_id=' + state.patientId)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        const filteredData = response?.data?.data?.filter(item => {
                            return item?.medication?.some(med => med.pharmacy_id === pharmaId);
                        });
                        updateState({
                            prescriptionTemplateList: filteredData || []
                        })
                    }
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const postTemplate = () => {
        try {
            let data = {}
            if (state.tempType === 'Add') {
                data = {
                    clinic_id: +state.clinicId,
                    template_id: state.selectedTemplate?.id || null,
                    pharmacy_id: state.selectedPharmacy,
                    template_name: state.templateName,
                    medication: state.prescriptionData?.map((item, index) => ({
                        ...item, 
                        dos_unit: item?.is_unit_ml ? "ML" :
                            item?.is_unit_others ? "Others" :
                                item?.dosage_unit ?? "Tablet",
                        quantity: item?.quantity ? item?.quantity : calcDuration(item?.duration_mode, item?.duration || null, item) || 0,
                    })) || []
                }
            } else if (state.tempType === 'rename') {
                data = {
                    clinic_id: state.clinicId,
                    template_name: state.templateName,
                    template_id: state.selectedTemplate?.id
                }
            }
            if (state.templateName === '') {
                errorMessage('Enter Template Name')
            } else {
                RestAPIService.create(data, Serviceurls.SARAS_DOC_PRESCRIPTION_TEMPLATE)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            successMessage(response.data.message)
                            getPrescriptionListData(state.prescriptionData?.[0]?.pharmacy_id || state.selectedPharmacy)
                            updateState({ tempType: '', openPopupAddNew: false, selectedTemplate: null, templateName: '', isEditDuration: false })
                        }
                    }).catch((error) => {
                        errorMessage(error?.response?.data?.message || error.message)
                    })
            }
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const closeDeletePopup = () => {
        updateState({
            deleteTemplateName: null,
            deletePopup: false
        })
    }

    const removeDataList = () => {
        try {
            updateState({ removeData: true })
            RestAPIService.delete(`${Serviceurls.DOC_DOCTOR_NOTES_PRESCRIPTION_TEMPLATE}?template_id=${state.deleteTemplateName?.id || 0}`)
                .then(response => {
                    if (response.data.status === "success") {
                        updateState({
                            deletePopup: false,
                            deleteTemplateName: null,
                            openPopupAddNew: false,
                            removeData: false
                        })
                        successMessage(response?.data?.message);
                        getPrescriptionListData(state.prescriptionData?.[0]?.pharmacy_id || state.selectedPharmacy)
                    }
                })
                .catch(error => {
                    if (error?.response?.data?.status === "fail") {
                        errorMessage(error?.response?.data?.message);
                        updateState({ removeData: false })
                    }
                });
        } catch (e) {
            errorMessage(e?.message);
            updateState({ removeData: false })
        }
    }

    const renderNewTemplatePopup = () => {
        try {
            let { tempType } = state
            return (
                <Box component={'div'}>
                    <Modal open={state.openPopupAddNew}>
                        <Box className='eMed_Doc_Notes_Test_Trans_Pop_Up'>
                            <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} p={'0.5vw'}>
                                <Typography fontWeight={600} color={Colors.SecondaryText}>{tempType === 'Add' ? 'Add New Template' : tempType === 'rename' ? 'Rename Template Name' : 'Delete Template'}</Typography>
                            </Box>
                            <Box component={'div'}>
                                <Box component={'div'} display={'flex'} justifyContent={'center'}>
                                    {tempType === 'Add' ?
                                        <Box component={'div'} display={'flex'}>
                                            {state.is_pharmacy ? null :
                                                <FormControl size='small' sx={{ width: '12vw', mr: '0.5vw' }}>
                                                    <InputLabel>Select Pharmacy</InputLabel>
                                                    <Select
                                                        label='select Pharmacy'
                                                        value={state.selectedPharmacy}
                                                        disabled={state.prescriptionData?.length > 0 && state.prescriptionData[0]?.pharmacy_id === state.selectedPharmacy && state.prescriptionData[0]?.pharmacy_id}
                                                        onChange={(e) => updateState({ selectedPharmacy: e.target.value })}
                                                    >
                                                        {state.pharmacyList?.length > 0 && state.pharmacyList?.map((item, index) => (
                                                            <MenuItem value={item?.pharmacy_id} key={index}>{item?.pharmacy_name}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>}
                                            <TextField
                                                size='small'
                                                sx={{ width: '12vw' }}
                                                inputProps={{ maxLength: 75 }}
                                                value={state.templateName}
                                                label='Enter Template Name'
                                                autoComplete='off'
                                                onChange={(e) => updateState({ templateName: e.target.value })}
                                            />

                                        </Box>
                                        : <TextField
                                            size='small'
                                            sx={{ width: '15vw' }}
                                            inputProps={{ maxLength: 75 }}
                                            autoComplete='off'
                                            value={state.templateName}
                                            label='Enter Template Name'
                                            onChange={(e) => updateState({ templateName: e.target.value })}
                                        />
                                    }
                                </Box>

                                <Box component={'div'} display={'flex'} justifyContent={'center'} mt={'0.5vw'}>
                                    <Button variant='contained'
                                        sx={{ width: '5vw', height: '2vw', textTransform: 'capitalize', mr: '1vw' }}
                                        onClick={() => {
                                            postTemplate()
                                        }}
                                    >Add</Button>
                                    <Button variant='outlined'
                                        sx={{ width: '5vw', height: '2vw', textTransform: 'capitalize' }}
                                        onClick={() => updateState({ tempType: '', openPopupAddNew: false, templateName: "" })}
                                    >Close</Button>
                                </Box>
                            </Box>
                        </Box>
                    </Modal>
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }
    //template popup end

    // favourite Popup start
    const getPrescriptionFavouriteData = () => {
        try {
            RestAPIService.getAll(Serviceurls.SARAS_DOC_PRESCRIPTION_FAVOURITE + '?patient_id=' + state.patientId)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        updateState({
                            prescriptionFav: response?.data?.data || [],
                            match_generic_list: response?.data?.match_generic_list || []
                        })
                    }
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderFavPopup = () => {
        try {
            return (
                <Box component={'div'}>
                    <Modal open={state.openFav}>
                        <Box component={'div'} className='eMed_Doc_Notes_Prescrip_Fav_Pop_Up'>
                            <Box component={'div'} display={'flex'} justifyContent={'space-between'} mt={'0.5vw'}>
                                <Typography pl={'0.5vw'} fontWeight={600} color={Colors.SecondaryText}>Select From Favourite</Typography>
                                <Button
                                    onClick={() => updateState({ openFav: false, selectedPrescripFav: [] })}
                                >
                                    <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1.1vw'} width={'1.1vw'} />
                                </Button>
                            </Box>
                            <Box component={'div'} display={'flex'} justifyContent={'center'} mt={'1vw'}>
                                <Autocomplete
                                    clearIcon
                                    size='small'
                                    multiple
                                    sx={{ width: '20vw' }}
                                    options={state.prescriptionFav || []}
                                    getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.drug_name}
                                    value={state.selectedPrescripFav || []}
                                    limitTags={3}
                                    autoComplete='off'
                                    onChange={(event, newValue) => {
                                        const hasHighAlert = newValue?.some(
                                            item =>
                                                item?.is_high_alert === true ||
                                                item?.is_look_alike === true ||
                                                item?.is_sound_alike === true
                                        );

                                        if (hasHighAlert && state?.enable_drug_alert && !state.isEdit) {
                                            updateState({
                                                selectedDrug: newValue[0]?.['drug_name'] || '',
                                                is_high_alert: newValue[0]?.['is_high_alert'] || false,
                                                is_look_alike: newValue[0]?.['is_look_alike'] || false,
                                                is_sound_alike: newValue[0]?.['is_sound_alike'] || false,
                                                lookAlikeDrugs: newValue[0]?.['look_alike_drugs'] || [],
                                                SoundAlikeDrugs: newValue[0]?.['sound_alike_drugs'] || [],
                                                highAlert: true,
                                                FavDrugData: newValue,
                                            });
                                            return;
                                        }
                                        updateState({ selectedPrescripFav: newValue })
                                    }}
                                    renderInput={(params) => <TextField {...params} label='Select Prescription' />}
                                />
                            </Box>
                            <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'} height={'3vw'}>
                                <Button
                                    sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize', mr: '1vw' }}
                                    variant='outlined'
                                    onClick={() => updateState({ selectedPrescripFav: [] })}
                                >Clear</Button>
                                <Button
                                    disabled={(!state.selectedPrescripFav || state.transmitted) ? true : false}
                                    sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize' }}
                                    variant='contained'
                                    onClick={() => {
                                         let hasAllergy = state.selectedPrescripFav?.some(item => item?.is_allergy)
                                        const creatArr = state.selectedPrescripFav?.map((item) => ({
                                            ...item,
                                            dosage_unit: item?.is_unit_ml ? "ML" : item?.is_unit_others ? "Others" : item?.dos_unit ?? "Tablet",
                                            quantity: item.quantity ? item.quantity : calcDuration(item.duration_mode, item.duration, item) || 0
                                        }));
                                        const newPrescriptionData = [...(state.prescriptionData || []), ...(creatArr || [])];
                                        if (hasAllergy) {
                                            updateState({ addPath: 'favorite', dupPrescriptionData: newPrescriptionData })
                                            setAllergyPopup(true)
                                        } else {
                                            PostPrescriptionData(newPrescriptionData)
                                        }
                                    }}
                                >Save</Button>
                            </Box>
                        </Box>
                    </Modal>
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }
    // favourite popup end

    // recall popup start
    const renderRecallPopup = () => {
        return (
            <Dialog
                open={state.recallPopup}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '0.5vw', marginBottom: '0vw' }}>
                    <img className="eMed_DeletePopup_CrossIcon" src={ImagePaths.LabCloseButton.default} alt='Close' onClick={() => { updateState({ recallPopup: false, recallReason: '', recallError: '' }) }} />
                </div>
                <DialogTitle id="alert-dialog-title">
                    <Typography component="div">
                        Recall Drug
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ fontSize: '0.8vw' }} id="alert-dialog-description">
                        Please provide a reason for recalling this prescription.
                    </DialogContentText>
                    <TextField
                              autoFocus
                              multiline
                              rows={3}
                              style={{ marginTop: '1vw' }}
                              fullWidth
                              variant="outlined"
                              label="Reason for Recall*"
                              value={state.recallReason || ''}
                              onChange={(e) => {
                                setState(prev => ({ 
                                    ...prev,
                                  recallReason: e.target.value,
                                  recallError: e.target.value.trim() ? '' : 'Reason is required'
                                }))
                              }}
                              inputProps={{ maxLength: 150 }}
                              error={!!state.recallError}
                              helperText={state.recallError}
                              placeholder="Enter the reason for recalling this prescription..."
                        />      
                </DialogContent>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: "center", justifyContent: "flex-end" }}>
                    <DialogActions sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Button size="small" variant="outlined" sx={{ textTransform: "capitalize" }} onClick={() => { updateState({ recallPopup: false,recallReason: '', recallError: '' }) }}>
                            {"Close"}
                        </Button>
                        <Button size="small" variant="contained" sx={{ textTransform: "capitalize" }} onClick={() => {
                            if (!state.recallReason?.trim()) {
                                setState(prev => ({
                                    ...prev,
                                    recallError: ''
                                }));
                                return;
                            }
                            postPrescriptionTransmit(true) }}
                            disabled={!state.recallReason?.trim()}>
                            {"Recall"}
                        </Button>
                    </DialogActions>
                </div>
            </Dialog>
        )
    }
    // recall popup end

    // success popup Start
    const renderSuccessPopup = () => {
        return (
            <div>
                <Modal
                    open={true}
                >
                    <Box component={'div'} className="eMed_Bill_Success_Preview_Main" height={'30vh'}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2vw' }}>
                            <Box sx={{ display: 'flex', gap: '1vw' }}>
                                <img src={ImagePaths.Tick.default} alt='success' />
                                <Typography fontWeight={600}>{state.successPopupTxt ? state.successPopupTxt : 'Transmitted Successfully'}</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', gap: '1vw' }}>
                                {state.smsSuccessTxt ? <ErrorIcon color='error' /> : <img src={ImagePaths.Tick.default} alt='success' />}
                                <Typography fontWeight={600}>{state.smsSuccessTxt ? state.smsSuccessTxt : 'SMS Sent Successfully'}</Typography>
                            </Box>
                        </Box>
                        <Box display={'flex'} gap={'0.5vw'}>
                            <Button sx={{ textTransform: 'capitalize', }} size="small" variant="outlined" onClick={() => { updateState({ successPopup: false }) }}>{"OK"}</Button>
                        </Box>
                    </Box>
                </Modal>
            </div>
        )
    }
    //sucess popup end

    const ClearData = () => {
        updateState({
            selectedDrug: '',
            searchedDrugList: [],
            searchedBrandName: '',
            searchedGenericName: "",
            genericList: [],
            dosageStrength: '',
            dosageType: '',
            morningQty: '0',
            afternoonQty: '0',
            eveningQty: '0',
            nightQty: '0',
            selectedUsage: '',
            selectedDays: '1',
            selectedDuration: '',
            durationDays: Days,
            durationWeeks: Weeks,
            durationMonts: Months,
            durationYears: Year,
            comments: '',
            favourite: false,
            selectedDrugId: null,
            removeData: false,
            selectedId: null,
            isEdit: false,
            selectedIndex: null,
            ExternalDrugAdd: state.is_pharmacy ? true : false,
            EditIndex: null,
            AddClicked: false,
            FrequencyText: "",
            DrugSuggestionList: [],
            AllowEdit: false,
            ExternalDrugName: '',
            ExternalGenericName: "",
            ExternalDosageStrength: "",
            ExternalDosageType: "",
            checkMl: false,
            ExternalDrugList: [],
            dupExternalDrugList: [],
            ExternalBrandName: '',
            checkOthers: false,
            stock_in_quantity: 0,
            addPath: '',
            dupPrescriptionData: [],
            dupUpdateArray: [],
            hasAllergy: false,
            selectedDosageForm: 'Tablet',
            presc_quantity: "",
            from_frequency: false,
            Selected_days:[],
            fo_external_drug_id: null,
            highAlert: false
        })
    }

    const addPrescriptionData = () => {
        try {
            let list = {}
            list = {
                afternoon: state.afternoonQty ? state.afternoonQty : '0',
                drug_name: state?.ExternalDrugAdd ? state?.ExternalDrugName : state.selectedDrug,
                comments: state.comments,
                drug_strength: state?.ExternalDrugAdd ? state?.ExternalDosageStrength : state.dosageStrength,
                dosage_type: state?.ExternalDrugAdd ? state?.ExternalDosageType : state.dosageType,
                drug_ms_id: state?.ExternalDrugAdd ? null : state.searchedGenericName?.drug_id ? state.searchedGenericName?.drug_id : state.selectedDrugId,
                duration: state.selectedDuration,
                duration_mode: state.selectedDays || "1",
                evening: state.eveningQty ? state.eveningQty : '0',
                generic_name: state?.ExternalDrugAdd ? state?.ExternalGenericName : state.searchedGenericName?.generic_name ? state.searchedGenericName?.generic_name : state.searchedGenericName,
                instructions: state.selectedUsage?.label ? instructions(state.selectedUsage?.label) : state.selectedUsage,
                is_favorite: state?.ExternalDrugAdd ? JSON.parse(JSON.stringify(state.ExternalIsFav)) : JSON.parse(JSON.stringify(state.favourite)),
                morning: state.morningQty ? state.morningQty : '0',
                night: state.nightQty ? state.nightQty : '0',
                id: state.selectedId ? state.selectedId : null,
                is_unit_ml: state.checkMl ? state.checkMl : state.selectedDosageForm === "ML",
                pharmacy_id: state.selectedPharmacy || '',
                is_tapper_meds: false,
                tapper_meds: [],
                is_unit_others: state.checkOthers ? state.checkOthers : state.selectedDosageForm === "Others",
                dosage_unit: state.selectedDosageForm || "Tablet",
                is_external_drug: state.ExternalDrugAdd ? true : false,
                quantity: showQty ? state.presc_quantity : 0,
                frequency: "",
                selective_days: state?.Selected_days?.map(item => convertDayToNumber(item)) || [],
                from_ai : state?.From_ai || false,
                fo_external_drug_id: state?.ExternalDrugAdd ? (state?.fo_external_drug_id || null) : null,
            }
            let isValid = checkValidation()
            if (isValid === null) {
                if (state.isCommonEdit) {
                    const data = CommonValidation.updateOrInsertList(state.prescriptionData, list, state.commonEditIdx)
                    PostPrescriptionData(data)
                } else {
                    const data = CommonValidation.updateOrInsertList(state.prescriptionList, list, state.selectedIndex)
                    updateState({
                        prescriptionList: data,
                        usagseId: null,
                        tapperExternal: state.is_pharmacy ? true : false,
                        ExternalBrandName: '',
                        ExternalDrugName: ''
                    })
                    ClearData()
                }
            } else {
                errorMessage(isValid)
            }
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const addTapperMedData = () => {
        try {
            let list = {};
            list = {
                afternoon: '0',
                comments: state.newTapMedComments,
                drug_ms_id: state?.newTapMedGenList?.drug_id ? state?.newTapMedGenList?.drug_id : null,
                duration: '0',
                duration_mode: '1',
                evening: '0',
                instructions: '',
                morning: '0',
                night: '0',
                id: state.selectedId ? state.selectedId : null,
                is_unit_ml: false,
                is_unit_others: false,
                dosage_unit: state.selectedDosageForm ?? "Tablet",
                pharmacy_id: state.selectedPharmacy || '',
                is_tapper_meds: true,
                tapper_meds: state.newTapMedDrugListData ? state.newTapMedDrugListData : [],
                quantity: 0,
                frequency: "",
            }
            if (state.tapperExternal) {
                list.drug_name = state.newTapExeSearchDrug?.drug_name ? state.newTapExeSearchDrug?.drug_name : state.newTapExeSearchDrug?.brand_name ? state.newTapExeSearchDrug?.brand_name : state.newTapExeSearchDrug
                list.generic_name = state.newTapMedExeGenericName ? state.newTapMedExeGenericName : ''
                list.drug_strength = state.newTapMedExeDosageStrength ? state.newTapMedExeDosageStrength : ''
                list.dosage_type = state?.newTapMedExeDosageType ? state?.newTapMedExeDosageType : ''
                list.is_favorite = JSON.parse(JSON.stringify(state?.newTapMedExeFav || false))
                list.is_external_drug = true
            } else {
                list.drug_name = state.newTapMedGenList?.drug_name ? state.newTapMedGenList?.drug_name : state.newTapMedGenList?.brand_name ? state.newTapMedGenList?.brand_name : ''
                list.generic_name = state.newTapMedGenList?.generic_name ? state.newTapMedGenList?.generic_name : ''
                list.drug_strength = state.newTapMedGenList?.dosage_strength ? state.newTapMedGenList?.dosage_strength : ''
                list.dosage_type = state?.newTapMedGenList?.dosage_type ? state?.newTapMedGenList?.dosage_type : ''
                list.is_favorite = state?.newTapMedGenList?.is_favorite ? JSON.parse(JSON.stringify(state?.newTapMedGenList?.is_favorite || false)) : false
                list.is_external_drug = false
            }

            let isValid = checkValidation()
            if (isValid === null) {
                if (state.isCommonEdit) {
                    const data = CommonValidation.updateOrInsertList(state.prescriptionData, list, state.commonEditIdx)
                    PostPrescriptionData(data)
                } else {
                    const data = CommonValidation.updateOrInsertList(state.tapperList, list, state.selectedIndex)
                    updateState({
                        tapperList: data,
                        usagseId: null,
                        tapperExternal: state.is_pharmacy ? true : false,
                        ExternalBrandName: '',
                        ExternalDrugName: ''
                    })
                    onClearTapMedHandler()
                }
            } else {
                errorMessage(isValid)
            }

        } catch (error) {
            errorMessage(error.message)
        }
    }

    const checkValidation = () => {
        try {
            let message = null;
            let isDrugValid = state?.ExternalDrugAdd ? true : (state.selectedDrug !== '') && (state.searchedGenericName === null) && (state.dosageStrength === '') && (state.dosageType === '')

            if (state.tabValue === '1') {
                if (state?.ExternalDrugAdd) {
                    if (state.ExternalDrugName === "") {
                        message = 'Select Brand name'
                    } else if (state.ExternalGenericName === "") {
                        message = 'Select Generic Name'
                    } else if (state.ExternalDosageType === "" || state.ExternalDosageStrength === "") {
                        message = 'Dosage Strength and Dosage Type is Empty'
                    } else if (((state.morningQty === '0' || state.morningQty === '') && (state.afternoonQty === '0' || state.afternoonQty === '') && (state.eveningQty === '0' || state.eveningQty === '') && (state.nightQty === '0' || state.nightQty === '')) && ((state.selectedUsage?.label !== "SOS") && (state.selectedUsage !== "SOS"))) {
                        message = 'Please Select MAEN Dosage Quantity'
                    } else if (!state.selectedDosageForm) {
                        message = 'Select Dosage Unit'
                    } else if (state.selectedDays === '' || state.selectedDuration === '') {
                        message = 'Select duration'
                    } else if (state.selectedUsage === '') {
                        message = 'Select Usage'
                    }
                } else {
                    if (state.selectedDrug === '') {
                        message = 'Select Brand name'
                    } else if (state.searchedGenericName === null || state.searchedGenericName === "") {
                        message = 'Select Generic Name'
                    } else if (state.dosageStrength === '' || state.dosageType === '') {
                        message = 'Dosage Strength and Dosage Type is Empty'
                    } else if ((((state.morningQty === '0' || state.morningQty === '') && (state.afternoonQty === '0' || state.afternoonQty === '') && (state.eveningQty === '0' || state.eveningQty === '') && (state.nightQty === '0' || state.nightQty === '')) && ((state.selectedUsage !== "SOS") && (state.selectedUsage?.label !== "SOS")))) {
                        message = 'Please Select MAEN Dosage Quantity'
                    } else if (!state.selectedDosageForm) {
                        message = 'Select Dosage Unit'
                    } else if (state.selectedDays === '' || state.selectedDuration === '') {
                        message = 'Select duration'
                    } else if (state.selectedUsage === '') {
                        message = 'Select Usage'
                    }
                }
            } else {
                if (state.tapperExternal) {
                    if ((state.newTapExeSearchDrug === null || state.newTapExeSearchDrug === '')) {
                        message = 'Enter Drug Details'
                    } else if (state.newTapMedDrugListData?.length === 0) {
                        message = 'Add atleast one tapper details'
                    }
                } else {
                    if ((state.newTapSearchDrug === null || state.newTapSearchDrug === '') && state.tapSelectedDrug === '') {
                        message = 'Enter Drug Details'
                    } else if (state.newTapMedDrugListData?.length === 0) {
                        message = 'Add atleast one tapper details'
                    }
                }
            }

            return message;
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const checkFinalValidation = (Data) => {
        try {
            let message = null;
            for (let i = 0; i < Data.length; i++) {
                const item = Data[i]?.tapper_meds.length > 0 ? Data[i]?.tapper_meds[0] : Data[i];
                if (item.drug_name === "") {
                    message = `Select Brand name`
                    break;
                } else if (item.generic_name === "") {
                    message = `Select Generic Name - ${item?.drug_name}`
                    break;
                } else if (item.dosage_type === "" || item.dosage_strength === "") {
                    message = `Dosage Strength and Dosage Type is Empty - ${item?.drug_name}`
                    break;
                } else if (((item.morning === '0' || item.morning === '') && (item.afternoon === '0' || item.afternoon === '') && (item.evening === '0' || item.evening === '') && (item.night === '0' || item.night === '')) && ((item.instructions?.label !== "SOS") && (item.instructions !== "SOS"))) {
                    message = `Please Select MAEN Dosage Quantity - ${item?.drug_name}`
                    break;
                } else if (!item.dosage_unit && !item.unit) {
                    message = `Select Dosage Unit - ${item?.drug_name}`
                    break;
                } else if (item.duration_mode === '' || item.duration === '') {
                    message = `Select duration - ${item?.drug_name}`
                    break;
                } else if (item.instructions === '') {
                    message = `Select Usage - ${item?.drug_name}`
                    break;
                }
            }
            return message;
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const drugValidation = async (path) => {
        try {
            let generiName = state?.ExternalDrugAdd
                ? state?.ExternalGenericName : state?.newTapMedGenList?.generic_name ? state?.newTapMedGenList?.generic_name
                    : state.newTapMedExeGenericName ? state.newTapMedExeGenericName
                        : state.searchedGenericName?.generic_name ? state.searchedGenericName?.generic_name
                            : state.searchedGenericName;
            if((state?.ExternalDrugAdd && !state.ExternalGenericName)){
                errorMessage("Select Generic Name")
                return
            }                           
            let params = `?patient_id=${PatientData?.patient_id}&generic_name=${encodeURIComponent(generiName)}`
            setIsLoader(true);
            const response = await RestAPIService.getAll(Serviceurls.ALLERGY_DRUG_VALIDATION + params)
            setIsLoader(false);
            if (response?.data?.status === 'success') {
                if (path == "prescription") {
                    addPrescriptionData()
                }
                else if (path == "tapperMed") {
                    addTapperMedData()
                }
            }
        } catch (error) {
            setIsLoader(false);
            if (error?.response?.data?.message == "This generic name is listed in patient medication allergies") {
                // setaddPath(path)
                updateState({addPath:path})
                setAllergyPopup(true)
            } else {
                errorMessage(error.message);
                return error.message;
            }
        }
    };

    const confirmSave = () => {
        if (state.addPath === 'copy') {
            copyPreviousPrescription()
        } else if (state.addPath === 'favorite') {
            PostPrescriptionData(state.dupPrescriptionData)
            setTimeout(() => {
                updateState({ dupPrescriptionData: [], dupUpdateArray: [], addPath: '', hasAllergy: false, dupSelectedPharmacy: null })
            }, 50)
        } else if (state.addPath === 'template') {
            PostPrescriptionData(state?.dupPrescriptionData)
            setTimeout(() => {
                updateState({ dupPrescriptionData: [], dupUpdateArray: [], addPath: '', hasAllergy: false, dupSelectedPharmacy: null })
            }, 50)
        } else if (state.addPath == "prescription") {
            addPrescriptionData()
        } else if (state.addPath == "tapperMed") {
            addTapperMedData()
        }
        setAllergyPopup(false)
    }

    const popClose = () => {
        setAllergyPopup(false)
        updateState({dupSelectedPharmacy:null,dupPrescriptionData:[],dupUpdateArray:[],addPath:'',hasAllergy:false})
        // setaddPath('')
    }

    const instructions = (item) => {
        let value = '';
        switch (item) {
            case 'Before Food':
                value = 'BF'
                break;
            case 'After Food':
                value = 'AF'
                break;
            case 'External Use':
                value = 'EU'
                break;
            case 'Empty Stomach':
                value = 'ES'
                break;
            case 'With Food':
                value = 'WF'
                break;
            default:
                value = item;
                break;
        }
        return value;
    }

    const onClearTapMedHandler = () => {
        try {
            updateState({
                newTapMedListData: [],
                newTapSearchDrug: null,
                newTapMedDate: new Date(),
                newTapMedOpenDate: false,
                newTapMedDrugListData: [],
                newTapMedDuration: '',
                newTapDurationType: 'Day(s)',
                newTapMedUnit: "",
                newTapMedUnitType: '',
                newTapMedFrequency: '',
                newTapMedReduceBy: '',
                newTapMedFreqTablet: null,
                newTapMedQty: '',
                newTapMedUsage: '',
                newTapMedComments: '',
                newTapMedGenList: {},
                isNewTapEdit: false,
                newTapMedSelectedIndex: null,
                leftSelectedIndex: null,
                dupTapMedDetails: '{}',
                newLftTapEdit: false,
                newTapMedId: null,
                newTapMedIsFav: false,
                AddClicked: false,
                isChange: false,
                tapUsage: '',
                tapMorning: '',
                tapAfternoon: '',
                tapEvening: '',
                tapNight: '',
                selMor: false,
                selAft: false,
                selEve: false,
                selNig: false,
                selectedTabCount: '',
                TapperDrugList: [],
                tapSelectedDrug: '',
                selectedDrugIdTap: null,
                // External 
                newTapExeSearchDrug: '',
                newTapMedExeDrugList: [],
                newTapMedExeDosageStrength: '',
                newTapMedExeDosageType: '',
                newTapMedExeGenericName: '',
                tempSearch: '',
                ExternalIsFav: false,
                newTapMedExeFav: false,
                newTapMedFreqTablet: '',
                newTapMedExeUnitType: 'mg'
            })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const closePrescPopup = () => {
        updateState({
            openPrescripton: false,
            isCommonEdit: false,
            commonEditIdx: null,
            isDeleteCliked: false,
            isEditDuration: false,
            openPrevious: false,
            prevPrescripData: [],
            selectedPrescripFav: [],
            openFav: false,
            tabValue: '1',
            disPres: false,
            disTapper: false,
            selectedTemplate: null,
        });
        ClearData();
        onClearTapMedHandler();
    }

    const renderPrescription = () => {
        return (
            <Modal open={state.openPrescripton} sx={{ outline: "none" }} disableEnforceFocus>
                <Box component={'div'} className='eMed_Doc_Notes_Prescrip_Pop_Up'
                    sx={{ width: "80dvw", height: "45dvw", display: "flex", flexDirection: "column" }}>
                    <Box component={'div'} p={'0.5dvw'} height={'2dvw'} display={'flex'} mt={"0.5dvw"} justifyContent={'space-between'} alignItems={'center'}>
                        <Typography style={{ paddingLeft: "0.5dvw" }} fontWeight={600} color={Colors.SecondaryText}>Add Medication</Typography>
                        <Button sx={{ marginRight: "-0.5dvw" }} onClick={closePrescPopup}>
                            <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1.1dvw'} width={'1.1dvw'} />
                        </Button>
                    </Box>
                    <Tabs
                        value={state.tabValue}
                        onChange={(e, newValue) => {
                            updateState({ tabValue: newValue })
                        }}
                    >
                        <Tab disabled={state.disPres} value="1" label={"Prescription"} className='eMed_tab_header' />
                        <Tab disabled={state.disTapper} value="2" label={"Taper Med"} className='eMed_tab_header' />
                    </Tabs>
                    {<Box component={"div"} style={{ padding: "0.5dvw", flex: 1, overflow: "hidden", display: 'flex', columnGap: "0.5dvw" }}>
                        {state.tabValue === "1" ? renderPresStep() : renderTaperStep()}
                    </Box>}
                    {<Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'} height={'3dvw'} padding={"0.5dvw"}>
                        <Button disabled={props.isLocked || state.transmitted}
                            onClick={() => {
                                if (state.isCommonEdit) {
                                    return state.tabValue === "1" ? addPrescriptionData() : addTapperMedData();
                                }
                                return PostPrescriptionData();
                            }}
                            sx={{ textTransform: 'capitalize' }}
                            variant='contained'
                        >{(is_save_transmit && !state.isCommonEdit && !state.isEdit) ? "Save & Transmit" : "Save"}</Button>
                    </Box>}
                </Box>
            </Modal>
        )
    }

    const getFreqDrugList = () => {
        try {
            RestAPIService.getAll(Serviceurls.SARAS_DOC_PRESCRIPTION_FREQUENT + `?pharmacy_id=${state.selectedPharmacy || ""}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        updateState({
                            FreqDrugList: response?.data?.drugs || [],
                            MedicationFav: response?.data?.tapper_drugs || [],
                        })
                    }
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderPharmaSlct = (isDisabled = false) => {
        return (
            <FormControl size='small' sx={{ width: '15vw', mr: '0.5dvw' }}>
                <InputLabel>Select Pharmacy</InputLabel>
                <Select
                    label='select Pharmacy'
                    disabled={isDisabled}
                    value={state.selectedPharmacy}
                    onChange={(e) => {
                        updateState({ selectedPharmacy: e.target.value })
                    }}
                >
                    {state.pharmacyList?.length > 0 && state.pharmacyList?.map((item, index) => (
                        <MenuItem value={item?.pharmacy_id} key={index}>{item?.pharmacy_name}</MenuItem>
                    ))}
                </Select>
            </FormControl>)
    }

    const renderTexfield = (label, stateKey) => {
        return (<TextField
            size='small'
            sx={{ width: '10vw', ml: '0.5vw' }}
            value={state[stateKey]}
            InputProps={{ readOnly: true }}
            label={label}
        />)
    }

    const getOptions = (option) => {
        try {
            let label = '';
            switch (option) {
                case 'ES':
                    label = "Empty Stomach"
                    break;
                case 'BF':
                    label = "Before Food"
                    break;
                case 'WF':
                    label = "With Food"
                    break;
                case 'AF':
                    label = "After Food"
                    break;
                case 'EU':
                    label = "External Use"
                    break;
                default:
                    label = option
                    break;
            }
            return label;
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getPresctiptionUsageList = () => {
        try {
            RestAPIService.getAll(Serviceurls.DOC_PRESCIPTION_USAGE_LIST)
                .then((response) => {
                    if (response.data.status === 'success') {
                        let data = response.data.data; let usageData = [];
                        Usage_Type?.forEach(element => usageData?.unshift(element))
                        data?.forEach(element => {
                            usageData?.push({
                                label: element?.instructions,
                                value: element?.instructions,
                                is_added: true,
                                id: element?.id
                            })
                        })
                        updateState({
                            prescriptionUsage: usageData,
                            usagseId: usageData?.find(item => item.label === state.selectedUsage)?.id
                        })
                    }
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const deletePresctiptionUsageList = (item) => {
        try {
            RestAPIService.delete(Serviceurls.DOC_PRESCIPTION_USAGE_LIST + '?id=' + item?.id)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        updateState({ selectedUsage: item?.id === state.usagseId ? '' : state.selectedUsage })
                        getPresctiptionUsageList()
                    }
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getMedicFrequency = () => {
        try {
            RestAPIService.getAll(Serviceurls.DOC_OPT_MEDICATION_FREQUENCY)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        let data = response.data.data
                        const uniqueArray = [...new Set(data)];
                        updateState({
                            frequencyTemplateList: uniqueArray,
                            frequency_list: response.data?.tapper_data ? response.data?.tapper_data : []
                        })
                    }
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const checkPresenceOfDosUnit = (value) => {
        return state.prescDosageFormList?.some(opt => opt.dosage_unit === value)
    } 

    const onCommonEditHandler = (item, index) => {
        const isTapper = item?.tapper_meds?.length > 0;
        const baseState = {
            openPrescripton: true,
            isCommonEdit: true,
            commonEditIdx: index,
            tabValue: isTapper ? "2" : "1",
            disPres: isTapper,
            disTapper: !isTapper,
            prescriptionId: item?.prescription_id || null,
            selectedDrugId: item?.drug_ms_id,
            selectedId: item?.id || null,
            isEdit: true,
            checkMl: item?.is_unit_ml || item?.dosage_unit === "ML",
            checkOthers: item?.is_unit_others || item?.dosage_unit === "Others",
            newTapMedComments: item?.comments,
            selectedDosageForm : item?.is_unit_ml ? "ML" : item?.is_unit_others ? "Others" : checkPresenceOfDosUnit(item?.dosage_unit) ? item?.dosage_unit : "",
            presc_quantity: (item?.tapper_meds?.length === 0 && showQty) ? (item?.quantity ? item?.quantity : calcDuration(item?.duration_mode ?? '1', item?.duration ?? 0, item)) : '',
            Selected_days:item?.selective_days?.map(item => convertNumberToDay(item)) || [],

        };

        if (!isTapper) {
            // Non-Tapper logic
            updateState({
                ...baseState,
                afternoonQty: `${item?.afternoon ?? ''}`,
                selectedDrug: item?.drug_name,
                comments: item?.comments,
                dosageStrength: item?.drug_strength,
                dosageType: item?.dosage_type,
                selectedDuration: item?.duration,
                selectedDays: item?.duration_mode || '1',
                eveningQty: `${item?.evening ?? ''}`,
                nightQty: `${item?.night ?? ''}`,
                morningQty: `${item?.morning ?? ''}`,
                favourite: item?.is_favorite ?? false,
                searchedGenericName: item?.generic_name,
                selectedUsage: item?.instructions,
            });

            if (!item?.drug_ms_id) {
                updateState({
                    ...baseState,
                    ExternalDrugAdd: true,
                    ExternalDrugName: item?.drug_name,
                    ExternalBrandName: item?.drug_name,
                    ExternalGenericName: item?.generic_name,
                    ExternalDosageType: item?.dosage_type,
                    ExternalDosageStrength: item?.drug_strength,
                    selectedDrug: '',
                    dosageStrength: '',
                    dosageType: '',
                    searchedGenericName: '',
                    ExternalIsFav: item?.is_favorite ?? false,
                    fo_external_drug_id: item?.fo_external_drug_id
                });
                getExternalDrugSearchList(item?.drug_name, '');
            } else {
                getMedicFrequency();
            }

        } else {
            // Tapper logic
            updateState({
                ...baseState,
                newTapMedDrugListData: JSON.parse(JSON.stringify(item?.tapper_meds || [])),
                newTapMedQty: item?.quantity || '',
                newTapMedGenList: JSON.parse(JSON.stringify(item)),
                newTapSearchDrug: item?.drug_name || '',
            });

            if (!item?.drug_ms_id) {
                updateState({
                    ...baseState,
                    tapperExternal: true,
                    newTapExeSearchDrug: item?.drug_name,
                    newTapMedExeDosageStrength: item?.drug_strength,
                    newTapMedExeDosageType: item?.dosage_type,
                    newTapMedExeGenericName: item?.generic_name,
                    tempSearch: '',
                    newTapMedExeFav: item?.is_favorite,
                });
            }
        }
    };


    const onEditHandler = (item, index) => {
        const baseState = {
            tabValue: "1",
            selectedIndex: index,
            afternoonQty: typeof (item?.afternoon) === 'string' ? item?.afternoon : (item?.afternoon).toString() || '',
            selectedDrug: item?.drug_name || '',
            comments: item?.comments,
            dosageStrength: item?.drug_strength || '',
            dosageType: item?.dosage_type || '',
            selectedDuration: item?.duration || '0',
            selectedDays: item?.duration_mode || '1',
            eveningQty: typeof (item?.evening) === 'string' ? item?.evening : (item?.evening).toString() || '0',
            nightQty: typeof (item?.night) === 'string' ? item?.night : (item?.night).toString() || '0',
            morningQty: typeof (item?.morning) === 'string' ? item?.morning : (item?.morning).toString() || '0',
            favourite: JSON.parse(JSON.stringify(item?.is_favorite)),
            searchedGenericName: item?.generic_name || '',
            selectedUsage: item?.instructions || '',
            From_ai: item?.From_ai || false,
            selectedDrugId: item?.drug_ms_id,
            selectedId: item?.id ? item?.id : null,
            isEdit: true,
            checkMl: item?.is_unit_ml ? item?.is_unit_ml : item?.dosage_unit === "ML",
            checkOthers: item?.is_unit_others ? item?.is_unit_others : item?.dosage_unit === "Others",
            selectedDosageForm : item?.is_unit_ml ? "ML" : item?.is_unit_others ? "Others" : checkPresenceOfDosUnit(item?.dosage_unit) ? item?.dosage_unit : "",
            presc_quantity: (item?.tapper_meds?.length === 0 && showQty) ? (item?.quantity ? item?.quantity : calcDuration(item?.duration_mode ?? '1', item?.duration ?? 0, item)) : '',
            Selected_days:item?.selective_days?.map(item => convertNumberToDay(item)) || [],

        }
        const externalState = !item?.drug_ms_id ? {
            ExternalDrugAdd: true,
            ExternalDrugName: item?.drug_name,
            ExternalBrandName: item?.drug_name,
            ExternalGenericName: item?.generic_name,
            ExternalDosageType: item?.dosage_type,
            ExternalDosageStrength: item?.drug_strength,
            selectedDrug: "",
            dosageStrength: "",
            dosageType: '',
            searchedGenericName: "",
            ExternalIsFav: item?.is_favorite ? item?.is_favorite : false,
            fo_external_drug_id: item?.fo_external_drug_id,
        } : {}
        updateState({ ...baseState, ...externalState });
        if (!item?.drug_id) {
            getExternalDrugSearchList(item?.drug_name, "")
        } else {
            getMedicFrequency()
        }
    }

    const onTapperEditHandler = (item, index) => {
        const baseState = {
            tabValue: "2",
            selectedIndex: index,
            comments: item?.comments,
            selectedDuration: '0',
            selectedDays: '1',
            eveningQty: '0',
            nightQty: '0',
            morningQty: '0',
            favourite: JSON.parse(JSON.stringify(item?.is_favorite)),
            searchedGenericName: '',
            selectedUsage: '',
            selectedDrugId: item?.drug_ms_id,
            selectedId: item?.id ? item?.id : null,
            isEdit: true,
            checkMl: item?.is_unit_ml ? item?.is_unit_ml : false,
            // Tapper state
            newTapMedDrugListData: item?.tapper_meds ? JSON.parse(JSON.stringify(item?.tapper_meds)) : [],
            newTapMedQty: item?.quantity ? item?.quantity : '',
            newTapMedGenList: item ? JSON.parse(JSON.stringify(item)) : {},
            newTapSearchDrug: item?.drug_name ? item?.drug_name : '',
            prescriptionId: item?.prescription_id ? item?.prescription_id : null,
            checkOthers: item?.is_unit_others ? item?.is_unit_others : false,
            newTapMedComments: item?.comments
        }
        const externalState = !item?.drug_ms_id ? {
            tapperExternal: true,
            newTapExeSearchDrug: item?.drug_name,
            newTapMedExeDosageStrength: item?.drug_strength,
            newTapMedExeDosageType: item?.dosage_type,
            newTapMedExeGenericName: item?.generic_name,
            tempSearch: '',
            newTapMedExeFav: item?.is_favorite,
        } : {}
        updateState({ ...baseState, ...externalState });
    }

    const deletePrescriptionData = (item) => {
        try {
            RestAPIService.delete(Serviceurls.SARAS_DOC_PRESCRIPTION_DATA + "?id=" + item?.id)
                .then((response) => {
                    if (response.data.status === "success") {
                        getPrescriptionData()
                        successMessage(response.data.message)
                    } else {
                        errorMessage(response.data.message)
                    }
                }).catch(error => {
                    errorMessage(error.message)
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const onDeleteHandler = (data, index, from = "fromPres") => {
        if (data.id === null) {
            try {
                const listMap = {
                    "fromTapper": "tapperList",
                    "fromPres": "prescriptionList",
                    "fromCommon": "prescriptionData",
                };

                const currentList = [...state[listMap[from]]];
                currentList.splice(index, 1);

                updateState({
                    [listMap[from]]: currentList,
                    selectedPharmacy: currentList[0]?.pharmacy_id || "",
                });

            } catch (error) {
                errorMessage(error.message);
            }
        } else {
            deletePrescriptionData(data)
        }
    };

    const disablePharma = useMemo(() => {
        const { prescriptionData, prescriptionList, tapperList, newTapMedListData, selectedPharmacy } = state;

        return ((prescriptionData?.length > 0 && prescriptionData[0]?.pharmacy_id === selectedPharmacy) ||
            (prescriptionList?.length > 0 && prescriptionList[0]?.pharmacy_id === selectedPharmacy) ||
            (tapperList?.length > 0 && tapperList[0]?.pharmacy_id === selectedPharmacy) ||
            (newTapMedListData?.length > 0 && newTapMedListData[0]?.pharmacy_id === selectedPharmacy))

    }, [state.prescriptionList, state.tapperList, state.newTapMedListData, state.selectedPharmacy, state.prescriptionData])

    const renderMaenTextFiled = (stateKey) => {
        return (
        <TextField size='small' sx={{ width: '5vw' }} InputProps={{ style: { height: '5vh' }, emed_tid: 'mrg_txt' }}
            value={state[stateKey]}
                onChange={(e) => {
                    let value = e.target.value;
                    if (value.startsWith(".")) return;
                    if (value === "") {
                        updateState({ [stateKey]: "" });
                        return;
                    }
                    if (!CommonValidation.DecimalNumberTwo(value)) return;
                    if (!value.includes(".")) {
                        value = value.replace(/^0+(?!$)/, "");
                    }
                    updateState({ [stateKey]: value })
                }}
        />)
    }

    const renderPresStep = () => {
        const notOftabMl = (state.selectedDosageForm !== "Tablet")
        const list = state.selectedDosageForm === "ML" ? state.tabletQty?.with_ml :
            (notOftabMl) ? state.tabletQty?.with_drops : state.tabletQty?.without_ml
        return (
            <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'row' }}>
                <Box sx={{ width: '60%', visibility: state.isCommonEdit ? "hidden" : "visible" }}>
                    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                        <TableContainer sx={{ height: '35vw', overflowY: 'auto' }}>
                            <Table size='small' stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell width={'2%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Favourite</TableCell>
                                        <TableCell width={'31%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Prescription</TableCell>
                                        <TableCell width={'28%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>M-A-E-N</TableCell>
                                        <TableCell width={'15%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>
                                            {"Duration"}
                                            <Button className='eMed_edit_btn_bill' disabled={props.isLocked || state.transmitted} sx={{ mb: "0.5vh" }}
                                                onClick={() => {
                                                    updateState({ isEditDuration: !state.isEditDuration })
                                                }}
                                            >
                                                <Tooltip placement='top' title='Edit' arrow>
                                                    <img className='eMed_header_img' src={ImagePaths.NewEditcon.default} alt='edit' />
                                                </Tooltip>
                                            </Button>
                                        </TableCell>
                                        {showQty && <TableCell width={'20%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Quantity</TableCell>}
                                        <TableCell width={'20%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Comments</TableCell>
                                        <TableCell width={'5%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        state.prescriptionList?.length > 0 ? state.prescriptionList?.map((item, index) => {
                                            const showMl = (item?.is_unit_ml || item?.dosage_unit === "ML") ? "ML" : ""
                                            return(
                                            <TableRow key={index}>
                                                <TableCell>
                                                    <Box component={'div'}>
                                                        <Button sx={{ justifyContent: 'flex-start', paddingTop: '0.5vw', }}
                                                            className='Common_Btn_Min_Width'
                                                            disabled={props.isLocked || state.transmitted}
                                                            onClick={() => {
                                                                const updatedPrescriptionList = [...state.prescriptionList];
                                                                updatedPrescriptionList[index] = {
                                                                    ...updatedPrescriptionList[index],
                                                                    is_favorite: !updatedPrescriptionList[index].is_favorite,
                                                                };

                                                                updateState({
                                                                    prescriptionList: updatedPrescriptionList,
                                                                    selectedPharmacy:
                                                                        updatedPrescriptionList.length > 0 && updatedPrescriptionList[0]?.pharmacy_id
                                                                            ? updatedPrescriptionList[0].pharmacy_id
                                                                            : "",
                                                                });
                                                            }}>
                                                            <Box component={'img'} src={item?.is_favorite ? ImagePaths.StarFill.default : ImagePaths.StarUnfill.default} height={'1.5vw'} width={'1.5vw'} />

                                                        </Button>
                                                    </Box>
                                                </TableCell>
                                                <TableCell>{item?.drug_name ?
                                                    <Box component={'div'}>
                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>
                                                            {item?.drug_name?.length > 15 ? (
                                                                <Tooltip placement='top' title={item?.drug_name}>
                                                                    <div>{item?.drug_name?.slice(0, 15) + '...'}</div>
                                                                </Tooltip>
                                                            ) : (
                                                                item?.drug_name
                                                            )}
                                                        </Typography>
                                                        <Typography display={"inline-flex"} fontSize={'0.8vw'} color={Colors.SecondaryText}>
                                                            {item?.generic_name ? (
                                                                item.generic_name.length > 15 ? (
                                                                    <Tooltip placement='top' title={item.generic_name}>
                                                                        <div>{item.generic_name.slice(0, 15) + '...'}</div>
                                                                    </Tooltip>
                                                                ) : (
                                                                    item.generic_name
                                                                )
                                                            ) : (
                                                                '-'
                                                            )} | {item?.drug_strength ? item.drug_strength : '-'} {item?.dosage_type || ''}
                                                        </Typography>
                                                    </Box> : '-'
                                                }</TableCell>
                                                {<><TableCell>
                                                    <Box component={'div'}>
                                                        <Typography fontSize={showMl ? '0.8vw' : '0.9vw'} fontWeight={600}>{`${item?.morning ? item?.morning : '0'}${showMl} - ${item?.afternoon ? item?.afternoon : '0'}${showMl} - ${item?.evening ? item?.evening : '0'}${showMl} - ${item?.night ? item?.night : '0'}${showMl}`}</Typography>
                                                        <Typography fontSize={'0.8vw'} color={Colors.SecondaryText}>{instructions(item?.instructions)}</Typography>
                                                    </Box>
                                                </TableCell>

                                                    <TableCell sx={{ fontSize: '0.9vw', fontWeight: 600 }}>
                                                        {state.isEditDuration ?
                                                            (<Box sx={{ display: "flex", flexDirection: "row", marginY: "0.5vw" }}>
                                                                <Autocomplete
                                                                    disableClearable
                                                                    forcePopupIcon={true}
                                                                    size="small" style={{ width: "6vw" }}
                                                                    value={item?.duration || ""}
                                                                    options={item.duration_mode === "1" ? Days : item.duration_mode === "2" ? Weeks : item.duration_mode === "3" ? Months : item.duration_mode === "5" ? Days : Year}
                                                                    getOptionLabel={(option) => typeof (option) === "string" ? option : (option?.label)}
                                                                    onChange={(event, newValue) => {
                                                                        let updatedPrescriptionLines = [...state.prescriptionList];
                                                                        updatedPrescriptionLines[index] = {
                                                                            ...updatedPrescriptionLines[index],
                                                                            duration: newValue ? newValue.value : null,
                                                                            quantity: calcDuration(updatedPrescriptionLines[index]?.duration_mode, newValue.value || null, updatedPrescriptionLines[index]) || 0,
                                                                        };
                                                                        updateState({ prescriptionList: updatedPrescriptionLines });
                                                                    }}
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            {...params}
                                                                            label={'Select Duration'}
                                                                        />
                                                                    )} />
                                                                <Box component={'div'} display={'flex'} alignItems={'center'} justifyContent={'space-between'} pr={"1vw"} pl={'0.8vw'}>
                                                                    <FormControl size='small'>
                                                                        <InputLabel>Select Duration</InputLabel>
                                                                        <Select
                                                                            sx={{ width: '6vw' }}
                                                                            label='Select Duration'
                                                                            value={item.duration_mode || ""}
                                                                            onChange={(e) => {
                                                                                let updatedPrescriptionLines = [...state?.prescriptionList];
                                                                                updatedPrescriptionLines[index] = {
                                                                                    ...updatedPrescriptionLines[index],
                                                                                    duration_mode: e.target.value,
                                                                                    duration: "",
                                                                                };
                                                                                updateState({ prescriptionList: updatedPrescriptionLines });
                                                                            }}
                                                                        >
                                                                            <MenuItem value={'1'}>Days</MenuItem>
                                                                            <MenuItem value={'2'}>Weeks</MenuItem>
                                                                            <MenuItem value={'3'}>Months</MenuItem>
                                                                            <MenuItem value={'4'}>Years</MenuItem>
                                                                            <MenuItem value={'5'}>Alternative Days</MenuItem>
                                                                        </Select>
                                                                    </FormControl>
                                                                </Box>
                                                            </Box>) :
                                                            <>
                                                                {`${item?.duration || item?.duration?.label || 0} ${durationOptions[item?.duration_mode] || ""}`}
                                                            </>
                                                        }

                                                        </TableCell>
                                                        {showQty && <TableCell width={'20%'} sx={{ fontSize: '0.9vw', fontWeight: 600 }}>
                                                            {state.isEditDuration ? (<TextField
                                                                autoComplete='off'
                                                                sx={{ width: '100%' }}
                                                                size='small'
                                                                value={item.quantity ?? ""}
                                                                inputProps={{ maxLength: 25 }}
                                                                onChange={(e) => {
                                                                    let updatedPrescriptionLines = [...state?.prescriptionList];
                                                                    updatedPrescriptionLines[index] = {
                                                                        ...updatedPrescriptionLines[index],
                                                                        quantity: e.target.value ? e.target.value : 0,
                                                                    };
                                                                    updateState({ prescriptionList: updatedPrescriptionLines });
                                                                }}
                                                                label={'Quantity'}
                                                            />) : (item?.quantity?.length > 10 ?
                                                                <Tooltip placement='top' title={item?.quantity}>
                                                                    <Typography fontWeight={600}>{item?.quantity?.slice(0, 10) + '...'}</Typography>
                                                                </Tooltip> :
                                                                <Typography fontWeight={600}>{item?.quantity ?? 0}</Typography>)}</TableCell>}
                                                    </>}
                                                
                                                <TableCell sx={{ fontSize: '0.9vw', fontWeight: 600 }}>{item?.comments ? item?.comments?.length > 10 ?
                                                    <Tooltip placement='top' title={item?.comments}><div>{item?.comments?.slice(0, 10) + '...'}</div></Tooltip> :
                                                    item?.comments : '-'}</TableCell>
                                                <TableCell >
                                                    <Box sx={{ fontSize: '0.9vw', fontWeight: 600, display: 'flex' }}>
                                                        <CommonEditButton size={"1.5vw"} disable={props.isLocked || state.transmitted} onClick={onEditHandler.bind(this, item, index)} />
                                                        <CommonDeleteButton size={"1.5vw"} disable={props.isLocked || state.transmitted} onClick={onDeleteHandler.bind(this, item, index, "fromPres")} />
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        )}) : <TableRow>
                                            <TableCell colSpan={headers.length} align="center">
                                                No Records To Be Shown
                                            </TableCell>
                                        </TableRow>
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Box>
                <Box sx={{ width: '40%', overflowY: "auto" }}>
                    <Typography style={{ paddingLeft: "0.5dvw" }} fontWeight={600} color={Colors.SecondaryText}>Prescription</Typography>
                    <Box marginTop={'1vw'} display={'flex'} justifyContent={'space-between'} p={'.5vw'}>
                        {renderPharmaSlct(disablePharma)}
                        <Button variant='outlined' size='small' sx={{ textTransform: 'capitalize' }}
                            onClick={() => {
                                updateState({ ExternalDrugAdd: !state.ExternalDrugAdd })
                            }}>{state.ExternalDrugAdd ? 'Pharmacy Drug' : 'External Drug'}</Button>
                    </Box>
                    {state.ExternalDrugAdd ?
                        <Box>
                            <Autocomplete
                                size='small'
                                sx={{ marginTop: '0.5vw', width: '19vw', ml: '0.5vw' }}
                                clearIcon
                                freeSolo
                                autoSelect={false}
                                options={state.ExternalDrugList ? state.ExternalDrugList : []}
                                getOptionLabel={option => typeof (option) === "string" ? option : option.drug_name}
                                value={state.ExternalBrandName ? state.ExternalBrandName : ''}
                                onChange={(e, value) => {
                                    const generic = value?.generic_name?.[0] || {};
                                    const isGeneric = value?.generic_name?.length === 1;
                                    const latest = generic.latest_prescription || {};
                                    const hasLatest = Object.keys(latest).length > 0;
                                    const updateLatest = isGeneric && hasLatest;
                                    updateState({
                                        ExternalDrugName: value?.drug_name || '',
                                        ExternalBrandName: value?.drug_name || '',
                                        ExternalGenericName: isGeneric ? generic.generic_name || '' : '',
                                        ExternalDosageType: isGeneric ? generic.dosage_type || '' : '',
                                        ExternalDosageStrength: isGeneric ? generic.dosage_strength || '' : '',
                                        ExternalIsFav: isGeneric ? generic.is_favorite || false : false,
                                        fo_external_drug_id: isGeneric ? (generic.fo_external_drug_id || null) : null,

                                        comments: updateLatest ? latest.comments || '' : '',
                                        morningQty: updateLatest ? latest.morning || '0' : '0',
                                        afternoonQty: updateLatest ? latest.afternoon || '0' : '0',
                                        eveningQty: updateLatest ? latest.evening || '0' : '0',
                                        nightQty: updateLatest ? latest.night || '0' : '0',

                                        checkMl: updateLatest ? latest.is_unit_ml || latest?.dos_unit === "ML" : false,
                                        selectedDuration: updateLatest ? latest.duration || '' : '',
                                        selectedDays: updateLatest ? latest.duration_mode || '1' : '1',
                                        checkOthers: updateLatest ? latest.is_unit_others || latest?.dos_unit === "Others" : false,
                                        selectedUsage: updateLatest ? latest.instructions || '' : '',
                                        selectedDosageForm : updateLatest ? latest?.is_unit_ml ? "ML" : latest?.is_unit_others ? "Others" : latest?.dos_unit ?? "Tablet" : "Tablet",

                                        genericSuggList: isGeneric ? [] : value?.generic_name || []
                                    });
                                }}
                                renderInput={(params) => <TextField {...params}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        if (val?.length > 0) {
                                            updateState({ ExternalDrugName: val })
                                            dobounceApiSearch.current(val, '')
                                        } else {
                                            updateState({
                                                dupExternalDrugList: [],
                                                ExternalDrugList: [],
                                                ExternalBrandName: '',
                                                ExternalDrugName: '',
                                                ExternalGenericName: '',
                                                ExternalDosageStrength: '',
                                                ExternalDosageType: '',
                                                stock_in_quantity: 0,
                                                fo_external_drug_id: null,
                                            })
                                        }
                                    }}
                                    label='Drug Name*' />}
                            />
                            <Box component={'div'} mt={'0.5vw'} sx={{ marginX: '0.5vw' }}>
                                <Box component={'div'} mt={'0.5vw'} display={'flex'}>
                                    <Autocomplete
                                        size='small'
                                        sx={{ width: '10vw' }}
                                        clearIcon
                                        freeSolo
                                        autoSelect={false}
                                        options={state.genericSuggList ? state.genericSuggList : []}
                                        getOptionLabel={option => typeof (option) === "string" ? option : option.generic_name}
                                        value={state.ExternalGenericName ? state.ExternalGenericName : ''}
                                        onChange={(e, value) => {
                                            updateState({
                                                ExternalGenericName: value?.generic_name,
                                                ExternalDosageStrength: value?.dosage_strength ? value?.dosage_strength : "",
                                                ExternalDosageType: value?.dosage_type ? value?.dosage_type : "",
                                            })
                                            if (value?.latest_prescription && Object.keys(value?.latest_prescription)?.length > 0) {
                                                updateState({
                                                    comments: value?.latest_prescription?.comments || "",
                                                    afternoonQty: value?.latest_prescription?.afternoon || "0",
                                                    eveningQty: value?.latest_prescription?.evening || "0",
                                                    morningQty: value?.latest_prescription?.morning || "0",
                                                    nightQty: value?.latest_prescription?.night || "0",
                                                    checkMl: value?.latest_prescription?.is_unit_ml || value?.latest_prescription?.dos_unit === "ML",
                                                    selectedDuration: value?.latest_prescription?.duration || "",
                                                    selectedDays: value?.latest_prescription?.duration_mode || "1",
                                                    checkOthers: value?.latest_prescription?.is_unit_others || value?.latest_prescription?.dos_unit === "Others",
                                                    selectedUsage: value?.latest_prescription?.instructions || "",
                                                    selectedDosageForm : value?.latest_prescription?.is_unit_ml ? "ML" : value?.latest_prescription?.is_unit_others ? "Others" : value?.latest_prescription?.dos_unit ?? "Tablet"
                                                })
                                            }
                                        }}
                                        renderInput={(params) => <TextField {...params}
                                            onChange={(e) => {
                                                updateState({
                                                    ExternalGenericName: e.target.value,
                                                    ExternalDosageStrength: "",
                                                    ExternalDosageType: ""
                                                })
                                            }}
                                            label='generic Name *' />}
                                    />
                                    <TextField
                                        size='small'
                                        sx={{ width: '10vw', ml: '0.5vw' }}
                                        value={state.ExternalDosageStrength}
                                        onChange={(e) => {
                                            if (CommonValidation.ALPHA_NUM_SPLCHAR(e.target.value) || e.target.value === "") {
                                                updateState({ ExternalDosageStrength: e.target.value })
                                            }
                                        }}
                                        label='Dosage Strength *'
                                    />
                                    <TextField
                                        size='small'
                                        sx={{ width: '10vw', ml: '0.5vw' }}
                                        value={state.ExternalDosageType}
                                        onChange={(e) => {
                                            const { value } = e.target;
                                            if (CommonValidation.ALPHA_NUM_SPLCHAR(value) || value === "") {
                                                updateState({
                                                    ExternalDosageType: value,
                                                    checkMl: value?.toLocaleLowerCase() === 'syrup',
                                                    checkOthers: (value?.toLocaleLowerCase() === 'drops' || value?.toLocaleLowerCase() === 'spray') ? true : false,
                                                    selectedDosageForm : value?.toLocaleLowerCase() === 'syrup' ? "ML" : (value?.toLocaleLowerCase() === 'drops' || value?.toLocaleLowerCase() === 'spray') ? "Others" : "Tablet"
                                                })
                                            }
                                        }}
                                        label='Dosage Type *'
                                    />
                                </Box>
                            </Box>
                        </Box>
                        : <Box>
                            {
                                state.FreqDrugList?.length > 0 ? state.FreqDrugList.map((item, index) => {
                                    const isSelected = item?.drug_name
                                        ? item?.drug_ms_id === state.selectedDrugId && item.drug_name === state.selectedDrug
                                        : item === state.selectedDrug;
                                    return (
                                        <Chip
                                            className={`eMed_chip ${(isSelected) ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                                            label={item.drug_name ? item?.drug_name : item}
                                            variant={(isSelected) ? 'contained' : 'outlined'}
                                            key={index}
                                            onClick={() => {
                                                updateState({
                                                    selectedDrug: item.drug_name ? item.drug_name : item,
                                                    // favourite: JSON.parse(JSON.stringify(item?.is_favorite)),
                                                    selectedDrugId: item?.drug_ms_id,
                                                    searchedGenericName: null,
                                                    dosageStrength: '',
                                                    dosageType: '',
                                                    from_frequency: true,
                                                })
                                            }}
                                            clickable
                                        />
                                    )
                                }) : null
                            }
                            <Autocomplete
                                size='small'
                                sx={{ margin: '0.5vw' }}
                                clearIcon
                                options={state.searchedDrugList}
                                getOptionLabel={(option) => typeof (option) === 'string' ? option : (state.drugSearchFor === 1 ? option.drug_name : `${option.drug_name} - ${option?.generic_name}`)}
                                value={state.selectedDrug ? state.selectedDrug : state.searchedBrandName ? state.searchedBrandName : ""}
                                onChange={(e, value) => {
                                    const isValidValue = !!value;
                                    const isBrandSearch = state.drugSearchFor === 1;

                                    const updatedState = {
                                        searchedBrandName: isValidValue ? value : '',
                                        selectedDrug: isValidValue ? value?.drug_name || "" : "",
                                        dosageStrength: "",
                                        dosageType: "",
                                        morningQty: "0",
                                        afternoonQty: "0",
                                        eveningQty: "0",
                                        nightQty: "0",
                                        selectedDays: "1",
                                        checkMl: false,
                                        checkOthers: false,
                                        selectedDuration: "",
                                        selectedUsage: "",
                                        comments: "",
                                        stock_in_quantity: 0,
                                        searchedGenericName: isValidValue && !isBrandSearch ? value?.generic_name : null,
                                        searchedDrugList: isValidValue ? state.searchedDrugList : [],
                                        selectedDosageForm: "Tablet",
                                        from_frequency: false,
                                    };

                                    updateState(updatedState);
                                }}
                                renderInput={(params) => <TextField {...params} label={'Search Drug'}
                                    onChange={(e) => {
                                        const inputValue = e.target.value;
                                        if (inputValue?.length > 1) {
                                            updateState({
                                                searchedBrandName: inputValue,
                                            })
                                            getPharmacyDrugSearchList(inputValue)
                                        }
                                    }}
                                />}
                                renderOption={(props, option) => (
                                    <li {...props} key={props['data-option-index']}>
                                        <Typography fontSize={'0.9vw'}>{state.drugSearchFor === 1 ? option.drug_name : `${option.drug_name} - ${option?.generic_name}`}</Typography>
                                    </li>
                                )}
                            />
                            <Box component={'div'} mt={'0.5vw'} sx={{ marginX: '0.5vw' }}>
                                <Box component={'div'} mt={'0.5vw'} display={'flex'}>
                                    <Autocomplete
                                        size='small'
                                        sx={{ width: '15vw' }}
                                        clearIcon
                                        freeSolo
                                        readOnly={state.drugSearchFor === 1 ? false : true}
                                        options={state.genericList}
                                        getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.generic_name}
                                        value={state.searchedGenericName ? state.searchedGenericName : ""}
                                        onChange={(e, value) => {
                                            updateState({
                                                searchedGenericName: value,
                                                dosageStrength: value?.dosage_strength,
                                                dosageType: value?.dosage_type,
                                                morningQty: value?.latest_prescription?.morning,
                                                afternoonQty: value?.latest_prescription?.afternoon,
                                                eveningQty: value?.latest_prescription?.evening,
                                                nightQty: value?.latest_prescription?.night,
                                                selectedDays: value?.latest_prescription?.duration_mode || "1",
                                                selectedDuration: value?.latest_prescription?.duration,
                                                selectedUsage: value?.latest_prescription?.instructions,
                                                comments: value?.latest_prescription?.comments,
                                                stock_in_quantity: value?.stock_in_quantity || 0,
                                                checkMl: value?.dosage_type?.toLocaleLowerCase() === 'syrup',
                                                checkOthers: (value?.dosage_type?.toLocaleLowerCase() === 'drops' || value?.dosage_type?.toLocaleLowerCase() === 'spray') ? true : false,
                                                selectedDosageForm : value?.dosage_type?.toLocaleLowerCase() === 'syrup' ? "ML" : (value?.dosage_type?.toLocaleLowerCase() === 'drops' || value?.dosage_type?.toLocaleLowerCase() === 'spray') ? "Others" : "Tablet"
                                            })
                                        }}
                                        renderInput={(params) => <TextField {...params}
                                            label='Select Generic Name *' />}
                                    />
                                    {renderTexfield('Dosage Strength', "dosageStrength")}
                                    {renderTexfield('Dosage Type', "dosageType")}
                                </Box>
                            </Box>
                        </Box>}
                    <Box component={'div'} mt={'0.5vw'} display={'flex'} flexDirection={'column'} alignItems={'center'}>
                        <Box component={'div'}>
                            <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                                <Typography fontSize={'0.9vw'} fontWeight={600}>{((state.selectedUsage?.label !== "SOS") && (state.selectedUsage !== "SOS")) ? "MAEN Dosage Quantity *" : "MAEN Dosage Quantity"}</Typography>
                                <Autocomplete
                                    clearIcon
                                    size='small'
                                    sx={{ width: '12vw' }}
                                    options={state.prescDosageFormList || []}
                                    getOptionLabel={(option) => typeof (option) === 'string' ? option : option.dosage_unit}
                                    value={state.prescDosageFormList?.find(opt => opt.dosage_unit === state.selectedDosageForm) || null}
                                    onChange={(e, newValue) => updateState({
                                        selectedDosageForm: newValue?.dosage_unit || "",
                                        morningQty: '0',
                                        eveningQty: '0',
                                        afternoonQty: '0',
                                        nightQty: '0',
                                        checkMl: newValue?.dosage_unit === "ML",
                                        checkOthers: newValue?.dosage_unit === "Others",
                                    })}
                                    renderInput={(params) => <TextField {...params} label={'Select Dosage Unit *'} />}
                                    renderOption={(props, item) => {
                                        return (
                                            <Box component={'div'} display={'flex'} justifyContent={'space-between'} key={props["data-option-index"]}>
                                                <Box component="li" {...props} width={'100%'}>
                                                    {item?.dosage_unit?.length > 15 ? (
                                                        <Tooltip placement="top" title={item.dosage_unit}>
                                                            <Typography component="span">{item.dosage_unit.slice(0, 15) + '...'}</Typography>
                                                        </Tooltip>
                                                    ) : (
                                                        <Typography component="span">{item.dosage_unit}</Typography>
                                                    )}
                                                </Box>
                                                {(item?.is_default === false) ?
                                                    <Button className='Common_Btn_Min_Width'
                                                        onClick={() => deleteDosageFormList(item)}
                                                    ><DeleteIcon color='error' /></Button> : null}
                                            </Box>
                                        )
                                    }}
                                    PaperComponent={({ children }) => {
                                        return (
                                            <Paper>
                                                {children}
                                                <Divider />
                                                <Button
                                                    color="primary"
                                                    fullWidth
                                                    sx={{ justifyContent: "flex-start", pl: 2, textTransform: 'capitalize' }}
                                                    onMouseDown={(e) => {
                                                        updateState({ openAddNewDosForm: true })
                                                    }}
                                                >
                                                    Add Dosage Form
                                                </Button>
                                            </Paper>
                                        )
                                    }}
                                />
                                {/* <FormControlLabel checked={state.checkMl} control={<Checkbox size='small' />}
                                    onChange={(e) => {
                                        const isChecked = e.target.checked;
                                        updateState({
                                            checkMl: isChecked,
                                            checkOthers: isChecked ? false : state.checkOthers,
                                            morningQty: '0',
                                            eveningQty: '0',
                                            afternoonQty: '0',
                                            nightQty: '0'
                                        })
                                    }} label='ML' />
                                <FormControlLabel checked={state.checkOthers} control={<Checkbox size='small' />}
                                    onChange={(e) => {
                                        const isChecked = e.target.checked;
                                        updateState({
                                            checkOthers: isChecked,
                                            checkMl: isChecked ? false : state.checkMl,
                                            morningQty: '0',
                                            eveningQty: '0',
                                            afternoonQty: '0',
                                            nightQty: '0'
                                        })
                                    }} label='Others' /> */}
                            </Box>
                            <Box component={'div'} display={'flex'} alignItems={'center'} mt={'0.5vw'}>
                                <Typography mr={'1.8vw'} fontSize={'0.9vw'} fontWeight={600}>Morning</Typography>
                                {list?.length > 0 && list?.map((item, index) => (
                                    <Chip
                                        className={`eMed_chip ${(state.selectedDosageForm === "ML" ? item.label2 : notOftabMl ? item?.label3 : item.label) === state.morningQty ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                                        label={state.selectedDosageForm === "ML" ? item.label2 : notOftabMl ? item?.label3 : item.label}
                                        variant={(state.selectedDosageForm === "ML" ? item.label2 : notOftabMl ? item?.label3 : item.label) === state.morningQty ? 'contained' : 'outlined'}
                                        key={index}
                                        onClick={() => {
                                            const selectedLabel = state.selectedDosageForm === "ML" ? item.label2 : notOftabMl ? item?.label3 : item.label;
                                            if (state.morningQty === selectedLabel) {
                                                updateState({ morningQty: "" });
                                            } else {
                                                updateState({ morningQty: state.selectedDosageForm === "ML" ? item.value2 : notOftabMl ? item?.value3 : item.value });
                                            }
                                        }}
                                        // color={'primary'}
                                        clickable
                                    />
                                ))}
                                {notOftabMl ? renderMaenTextFiled("morningQty") : null}
                            </Box>
                            <Box component={'div'} display={'flex'} alignItems={'center'}>
                                <Typography sx={{ mr: '1vw' }} fontSize={'0.9vw'} fontWeight={600}>Afternoon</Typography>
                                {list?.length > 0 && list?.map((item, index) => (
                                    <Chip
                                        className={`eMed_chip ${(state.selectedDosageForm === "ML" ? item.label2 : notOftabMl ? item?.label3 : item.label) === state.afternoonQty ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                                        label={state.selectedDosageForm === "ML" ? item.label2 : notOftabMl ? item?.label3 : item.label}
                                        variant={(state.selectedDosageForm === "ML" ? item.label2 : notOftabMl ? item?.label3 : item.label) === state.afternoonQty ? 'contained' : 'outlined'}
                                        key={index}
                                        onClick={() => {
                                            const selectedLabel = state.selectedDosageForm === "ML" ? item.label2 : notOftabMl ? item?.label3 : item.label;
                                            if (state.afternoonQty === selectedLabel) {
                                                updateState({ afternoonQty: "" });
                                            } else {
                                                updateState({ afternoonQty: state.selectedDosageForm === "ML" ? item.value2 : notOftabMl ? item?.value3 : item.value });
                                            }
                                        }}
                                        // color={'primary'}
                                        clickable
                                    />
                                ))}
                                {notOftabMl ? renderMaenTextFiled("afternoonQty") : null}
                            </Box>
                            <Box component={'div'} display={'flex'} alignItems={'center'}>
                                <Typography mr={'2vw'} fontSize={'0.9vw'} fontWeight={600}>Evening</Typography>
                                {list?.length > 0 && list?.map((item, index) => (
                                    <Chip
                                        className={`eMed_chip ${(state.selectedDosageForm === "ML" ? item.label2 : notOftabMl ? item?.label3 : item.label) === state.eveningQty ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                                        label={state.selectedDosageForm === "ML" ? item.label2 : notOftabMl ? item?.label3 : item.label}
                                        variant={(state.selectedDosageForm === "ML" ? item.label2 : notOftabMl ? item?.label3 : item.label) === state.eveningQty ? 'contained' : 'outlined'}
                                        key={index}
                                        onClick={() => {
                                            const selectedLabel = state.selectedDosageForm === "ML" ? item.label2 : notOftabMl ? item?.label3 : item.label;
                                            if (state.eveningQty === selectedLabel) {
                                                updateState({ eveningQty: "" });
                                            } else {
                                                updateState({ eveningQty: state.selectedDosageForm === "ML" ? item.value2 : notOftabMl ? item?.value3 : item.value });
                                            }
                                        }}
                                        // color={'primary'}
                                        clickable
                                    />
                                ))}
                                {notOftabMl ? renderMaenTextFiled("eveningQty") : null}
                            </Box>
                            <Box component={'div'} display={'flex'} alignItems={'center'}>
                                <Typography mr={'3vw'} fontSize={'0.9vw'} fontWeight={600}>Night</Typography>
                                {list?.length > 0 && list?.map((item, index) => (
                                    <Chip
                                        className={`eMed_chip ${(state.selectedDosageForm === "ML" ? item.label2 : notOftabMl ? item?.label3 : item.label) === state.nightQty ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                                        label={state.selectedDosageForm === "ML" ? item.label2 : notOftabMl ? item?.label3 : item.label}
                                        variant={(state.selectedDosageForm === "ML" ? item.label2 : notOftabMl ? item?.label3 : item.label) === state.nightQty ? 'contained' : 'outlined'}
                                        key={index}
                                        onClick={() => {
                                            const selectedLabel = state.selectedDosageForm === "ML" ? item.label2 : notOftabMl ? item?.label3 : item.label;
                                            if (state.nightQty === selectedLabel) {
                                                updateState({ nightQty: "" });
                                            } else {
                                                updateState({ nightQty: state.selectedDosageForm === "ML" ? item.value2 : notOftabMl ? item?.value3 : item.value });
                                            }
                                        }}
                                        // color={'primary'}
                                        clickable
                                    />
                                ))}
                                {notOftabMl ? renderMaenTextFiled("nightQty") : null}
                            </Box>
                        </Box>
                        <Box component={'div'} pl={'0.5vw'}>
                            <Box component={'div'} display={'flex'} alignItems={'center'} justifyContent={'space-between'} marginY={'0.5vw'} pr={"1vw"} pl={'0.8vw'}>
                                <Typography fontSize={'0.9vw'} fontWeight={600}>Duration *</Typography>
                                <FormControl size='small'>
                                    <InputLabel>Select Duration</InputLabel>
                                    <Select
                                        sx={{ width: '10vw' }}
                                        label='Select Duration'
                                        value={state.selectedDays}
                                        onChange={(e) => updateState({ selectedDays: e.target.value, selectedDuration: '', presc_quantity: '' })}
                                    >
                                        <MenuItem value={'1'}>Days</MenuItem>
                                        <MenuItem value={'2'}>Weeks</MenuItem>
                                        <MenuItem value={'3'}>Months</MenuItem>
                                        <MenuItem value={'4'}>Years</MenuItem>
                                        <MenuItem value={'5'}>Alternative Days</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box component={'div'} mt={'0.5vw'}>
                                {(state.selectedDays === '1' || state.selectedDays === '5') ?
                                    state.durationDays?.map((item, index) => (
                                        <Chip
                                            className={`eMed_chip ${item.value === state.selectedDuration ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                                            label={item.label}
                                            variant={item.value === state.selectedDuration ? 'contained' : 'outlined'}
                                            key={index}
                                            onClick={() => { updateState({ selectedDuration: item?.value }) }}
                                            clickable
                                        />
                                    )) : state.selectedDays === '2' ?
                                        state.durationWeeks?.map((item, index) => (
                                            <Chip
                                                className={`eMed_chip ${item.value === state.selectedDuration ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                                                label={item.label}
                                                variant={item.value === state.selectedDuration ? 'contained' : 'outlined'}
                                                key={index}
                                                onClick={() => { updateState({ selectedDuration: item?.value }) }}
                                                clickable
                                            />
                                        )) : state.selectedDays === '3' ?
                                            state.durationMonts?.map((item, index) => (
                                                <Chip
                                                    className={`eMed_chip ${item.value === state.selectedDuration ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                                                    label={item.label}
                                                    variant={item.value === state.selectedDuration ? 'contained' : 'outlined'}
                                                    key={index}
                                                    onClick={() => { updateState({ selectedDuration: item?.value }) }}
                                                    clickable
                                                />
                                            )) : state.durationYears?.map((item, index) => (
                                                <Chip
                                                    className={`eMed_chip ${item.value === state.selectedDuration ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                                                    label={item.label}
                                                    variant={item.value === state.selectedDuration ? 'contained' : 'outlined'}
                                                    key={index}
                                                    onClick={() => { updateState({ selectedDuration: item?.value }) }}
                                                    clickable
                                                />
                                            ))
                                }
                            </Box>
                        </Box>
                    </Box>
                    <Box component={'div'} mt={'0.5vw'} display={'flex'} flexDirection={'column'}>
                        {showQty && <TextField
                            autoComplete='off'
                            sx={{ width: '14dvw', margin: '0.5vw 0.5vw 0.5vw 1.5vw' }}
                            size='small'
                            value={state.presc_quantity ?? ""}
                            inputProps={{ maxLength: 25 }}
                            onChange={(e) => {
                                updateState({ presc_quantity: e.target.value })
                            }}
                            label={'Quantity'}
                        />}
                        <Autocomplete
                            clearIcon
                            size='small'
                            sx={{ width: '28vw', marginLeft: '1.5vw' }}
                            options={state.prescriptionUsage}
                            getOptionLabel={(option) => typeof (option) === 'string' ? getOptions(option) : option.label}
                            value={state.selectedUsage}
                            onChange={(e, value) => updateState({ selectedUsage: value })}
                            renderInput={(params) => <TextField {...params} label={'Select Usage *'} />}
                            renderOption={(props, item) => {
                                return (
                                    <Box component={'div'} display={'flex'} justifyContent={'space-between'} key={props["data-option-index"]}>
                                        <Box component="li" {...props} width={'100%'}>
                                            <Typography>{item?.label}</Typography>
                                        </Box>
                                        {item?.is_added ?
                                            <Button className='Common_Btn_Min_Width'
                                                onClick={() => deletePresctiptionUsageList(item)}
                                            ><DeleteIcon color='error' /></Button> : null}
                                    </Box>
                                )
                            }}
                            PaperComponent={({ children }) => {
                                return (
                                    <Paper>
                                        {children}
                                        <Divider />
                                        <Button
                                            color="primary"
                                            fullWidth
                                            sx={{ justifyContent: "flex-start", pl: 2, textTransform: 'capitalize' }}
                                            onMouseDown={(e) => {
                                                updateState({ openAddNew: true })
                                            }}
                                        >
                                            Add Usage
                                        </Button>
                                    </Paper>
                                )
                            }}
                        />
                        <Box>          
                        {(localGetItem('show_selective_days_in_prescription') === "true") ?(
                        <FormControl sx={{ m: 1, width: '28vw', marginLeft:'1.5vw' }}size="small" >
                            <InputLabel >Select Days</InputLabel>
                            <Select
                            multiple
                            size='small'
                            value={state?.Selected_days}
                            onChange={handleChange}
                            input={<OutlinedInput label="Select Days" />}
                            >
                            {Prescription_Days.map((days) => (
                                <MenuItem
                                key={days}
                                value={days}
                                >
                                {days}
                                </MenuItem>
                            ))}
                            </Select>
                        </FormControl>
                        ) : null}
                        </Box>
                        <Box component={'div'}>
                            <TextField
                                size='small'
                                className='eMed_DocNotes_TextFields'
                                multiline={true}
                                rows={3}
                                label={"Comments"}
                                inputProps={{ maxLength: 250 }}
                                value={state.comments}
                                onChange={(e) => {
                                    let value = e.target.value
                                    if (value?.length < 100) {
                                        updateState({ comments: e.target.value })
                                    } else {
                                        errorMessage('Allowed only 100 characters')
                                    }
                                }}
                            />
                        </Box>
                    </Box>
                    <Stack spacing={2} direction="row" sx={{ backgroundColor: Colors.DataTblHeaderbg, visibility: state.isCommonEdit ? "hidden" : "visible" }} alignItems="center" justifyContent="center" height={"5.5vh"}>
                        <Button variant='outlined' size="small" _id="eMed_Config_btn" onClick={() => { ClearData(true) }}>Clear</Button>
                        <Button variant='contained' size="small" id="eMed_Config_btn" onClick={() => { drugValidation("prescription") }}>Add</Button>
                    </Stack>
                </Box>
            </Box>
        )
    }

    const getPharmacyDrugSearchList = (searchValue) => {
        try {
            let params = '';
            if (state.tabValue === '1') {
                if (state.drugSearchFor === 1) {
                    params = `?brand_name=${searchValue}&generic_name=&clinic_id=${state.clinicId}&pharmacy_id=${state.selectedPharmacy}`
                } else if (state.drugSearchFor === 2) {
                    params = `?brand_name=&generic_name=${searchValue}&clinic_id=${state.clinicId}&pharmacy_id=${state.selectedPharmacy}`
                } else {
                    params = `?search_key=${searchValue}&brand_name=&generic_name=&clinic_id=${state.clinicId}&pharmacy_id=${state.selectedPharmacy}`
                }
            } else {
                params = `?brand_name=${searchValue}&generic_name=&clinic_id=${state.clinicId}&pharmacy_id=${state.selectedPharmacy}&is_tapper_meds=true`
            }
            RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_DRUG_SEARCH + params)
                .then((response) => {
                    if (response.data.status === 'success') {
                        let data = response.data.data
                        let uniqueArray = data?.filter((item, index, self) =>
                            index === self.findIndex((t) => (
                                t.drug_name === item.drug_name
                            ))
                        );
                        if (state.tabValue === '1') {
                            updateState({
                                searchedDrugList: state.drugSearchFor === 1 ? uniqueArray : response.data.data,
                            })
                        } else {
                            updateState({
                                TapperDrugList: uniqueArray,
                                tapSelectedDrug: ''
                            })
                        }
                    }
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const highAlertpopupClose = () => {
        updateState({
            highAlert: false,
            pendingGenericListData: null,
            skipHighAlertCheck: false,
            forceRefreshDrug: true,
            FavDrugData: []
        });
        ClearData()
        onClearTapMedHandler()
    }

    const highAlertpopupConfirm = () => {
        if (state?.FavDrugData) {
            updateState({
                highAlert: false,
                selectedPrescripFav: state?.FavDrugData,
            });
        } else {
            updateState({
                highAlert: false,
                skipHighAlertCheck: true,
            });
        }
    }

    useEffect(() => {
        if (state.skipHighAlertCheck) {
            getGenericNameList(false, state.isCommonEdit || state.isEdit);
        }
    }, [state.skipHighAlertCheck]);

    const getGenericNameList = (fromFreq = false, isFromEdit = false) => {
        try {
            let params = ''
            let Apicall = true
            if (state.tabValue === '1') {
                if (fromFreq) {
                    params = `?brand_name=${encodeURIComponent(state.selectedDrug)}&generic_name=&clinic_id=${state.clinicId}&pharmacy_id=${state.selectedPharmacy}`
                } else {
                    if (+state.drugSearchFor === 1) {
                        params = `?brand_name=${encodeURIComponent(state.selectedDrug)}&generic_name=&clinic_id=${state.clinicId}&pharmacy_id=${state.selectedPharmacy}`
                    } else {
                        params = `?brand_name=${encodeURIComponent(state.selectedDrug)}&generic_name=${encodeURIComponent(state.searchedGenericName)}&clinic_id=${state.clinicId}&pharmacy_id=${state.selectedPharmacy}`
                        if(typeof (state.searchedGenericName) === "object"){
                            Apicall = false
                        }
                    }
                }
            } else {
                let brandName = state.newTapSearchDrug?.drug_name ? state.newTapSearchDrug?.drug_name : state.newTapSearchDrug ? state.newTapSearchDrug : state.tapSelectedDrug
                let generic_name = state.newTapSearchDrug?.generic_name ? state.newTapSearchDrug?.generic_name : ''
                params = `?brand_name=${encodeURIComponent(brandName)}&generic_name=${encodeURIComponent(generic_name)}&clinic_id=${state.clinicId}&pharmacy_id=${state.selectedPharmacy}&is_tapper_meds=true`
            }
            if(Apicall){
                RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_GENERIC_NAME_GET + params)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            const genericList = response?.data?.data || [];

                            const hasHighAlert = genericList?.some(
                                item => item?.is_high_alert || item?.is_look_alike || item?.is_sound_alike
                            );

                            if (hasHighAlert && !state.skipHighAlertCheck && state.enable_drug_alert) {
                                updateState({
                                    selectedDrug: genericList[0]?.['drug_name'] || '',
                                    is_high_alert: genericList[0]?.['is_high_alert'] || false,
                                    is_look_alike: genericList[0]?.['is_look_alike'] || false,
                                    is_sound_alike: genericList[0]?.['is_sound_alike'] || false,
                                    lookAlikeDrugs: genericList[0]?.['look_alike_drugs'] || [],
                                    SoundAlikeDrugs: genericList[0]?.['sound_alike_drugs'] || [],
                                    pendingGenericListData: genericList,
                                    highAlert: true
                                });
                                return;
                            }

                            const finalGenericList = state?.skipHighAlertCheck ? (state.pendingGenericListData || genericList) : genericList;
                            if (state.tabValue === '1') {
                                const genericList = response?.data?.data || [];
                                const searchedGenericName = finalGenericList[0] || {};
                                const latestPresc = searchedGenericName?.latest_prescription || {};
                                const hasLatest = Object.keys(latestPresc).length > 0;
                                const dosageType = searchedGenericName?.dosage_type?.toLowerCase();

                                const stateUpdate = {
                                    genericList,
                                    searchedGenericName,
                                    dosageStrength: searchedGenericName?.dosage_strength,
                                    dosageType: searchedGenericName?.dosage_type,
                                    stock_in_quantity: searchedGenericName?.stock_in_quantity || 0,
                                    from_frequency: false,
                                };

                                if (!isFromEdit && hasLatest) {
                                    Object.assign(stateUpdate, {
                                        checkMl: latestPresc?.is_unit_ml || latestPresc?.dos_unit === "ML",
                                        morningQty: latestPresc?.morning,
                                        afternoonQty: latestPresc?.afternoon,
                                        eveningQty: latestPresc?.evening,
                                        nightQty: latestPresc?.night,
                                        selectedDays: latestPresc?.duration_mode || "1",
                                        selectedDuration: latestPresc?.duration,
                                        selectedUsage: latestPresc?.instructions,
                                        comments: latestPresc?.comments,
                                        checkOthers: latestPresc?.is_unit_others || latestPresc?.dos_unit === "Others",
                                        selectedDosageForm: latestPresc?.is_unit_ml ? "ML" : latestPresc?.is_unit_others ? "Others" : latestPresc?.dos_unit ?? "Tablet",
                                    });
                                }

                                if (!isFromEdit && !hasLatest) {
                                    stateUpdate.checkMl = dosageType === 'syrup';
                                    stateUpdate.checkOthers = dosageType === 'drops' || dosageType === 'spray';
                                    stateUpdate.selectedDosageForm = dosageType === 'syrup' ? "ML" :
                                        (dosageType === 'drops' || dosageType === 'spray') ? "Others" : "Tablet"
                                    if (!stateUpdate.checkMl && !stateUpdate.checkOthers) {
                                        stateUpdate.checkMl = false;
                                        stateUpdate.checkOthers = false;
                                    }
                                }
                                updateState({
                                    ...stateUpdate,
                                    pendingGenericListData: null,
                                });
                            } else {
                                const genericList = response?.data?.data || [];
                                if (genericList?.length > 0) {
                                    const unit = genericList[0]?.dosage_strength ? genericList[0]?.dosage_strength?.match(/\d+/) : genericList[0]?.dosage_strength
                                    updateState({
                                        newTapMedGenList: genericList[0],
                                        stock_in_quantity: genericList[0]?.stock_in_quantity || 0,
                                        newTapMedUnitType: 'mg',
                                        newTapMedUnit: unit ? unit[0] : genericList[0]?.dosage_strength,
                                        pendingGenericListData: null,
                                    })
                                }
                            }
                        }
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error.message)
                })
            }
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const postPresctiptionUsageList = () => {
        try {
            updateState({ postUsageLoad: true })
            const data = {
                "instructions": state.prescUsage
            }
            if (state.prescUsage === null || state.prescUsage === '') {
                updateState({ postUsageLoad: false })
                errorMessage('Please Enter Usage')
            } else {
                RestAPIService.create(data, Serviceurls.DOC_PRESCIPTION_USAGE_LIST)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            successMessage(response.data.message)
                            updateState({
                                selectedUsage: state.prescUsage,
                                openAddNew: false,
                                postUsageLoad: false,
                                prescUsage: null
                            })
                            getPresctiptionUsageList()
                        }
                    }).catch((error) => {
                        updateState({ postUsageLoad: false })
                        errorMessage(error?.response?.data?.message || error.message)
                    })
            }
        } catch (error) {
            updateState({ postUsageLoad: false })
            errorMessage(error.message)
        }
    }

    const handleInputChange = debounce((value) => {
        updateState({ newTapSearchDrug: value })
        if (value) {
            getPharmacyDrugSearchList(value)
        } else {
            onClearTapMedHandler()
        }
    }, 500)

    const onNewTappperMedAddHandler = () => {
        try {
            let startDate = new Date(state.newTapMedDate)
            let newTapStartDate = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
            var duration = state.newTapMedDuration
            let frequency = ''; let reducedBy = ''; let dosageCountLabel = ''; let frequencyLabel = '';

            frequency = ''
            reducedBy = state.newTapMedReduceBy ? state.newTapMedReduceBy : 0

            dosageCountLabel = state.newTapMedExeUnitType
            frequencyLabel = state.newTapMedFreqTablet

            if (state.newTapDurationType === "Week(s)") {
                duration = +(state.newTapMedDuration) * 7
            } else if (state.newTapDurationType === "Month(s)") {
                duration = +(state.newTapMedDuration) * 30
            }

            let date = new Date(startDate);
            date.setDate(date.getDate() + (+duration));

            let tapperDetails = {
                start_date: newTapStartDate,
                no_of_dosage: state.newTapMedUnit + " " + dosageCountLabel,
                duration: state.newTapMedDuration + " " + state.newTapDurationType,
                end_date: DateTime.fromJSDate(date).toFormat('yyyy-MM-dd'),
                frequency: frequency + frequencyLabel,
                reducedBy: reducedBy,
                instructions: state.newTapMedUsage,
                unit: state.newTapMedUnit,
                unitType: dosageCountLabel,
                duration1: state.newTapMedDuration,
                durationType: state.newTapDurationType,
                usage: state.newTapMedUsage,
                quantity: state.newTapMedQty,
                morning: state.tapMorning,
                evening: state.tapEvening,
                afternoon: state.tapAfternoon,
                night: state.tapNight,
                selMor: state.selMor,
                selAft: state.selAft,
                selEve: state.selEve,
                selNig: state.selNig,
                tablet_count: state.selectedTabCount
            }
            tapperDetails.freq = state.newTapMedFreqTablet
            let chekNewTap = newCheckTapValidation(tapperDetails)
            if (chekNewTap === null) {
                if (state.isNewTapEdit) {
                    state.newTapMedDrugListData[state.newTapMedSelectedIndex] = tapperDetails
                } else {
                    state.newTapMedDrugListData?.push(tapperDetails)
                }

                let nextDate = new Date(date)
                nextDate.setDate(nextDate.getDate() + 1)
                if (frequency == 1) {
                    frequency = frequency
                } else if (frequency == 12) {
                    frequency = 10
                } else if (frequency == 10) {
                    frequency = 6
                } else {
                    frequency = +(frequency) - 1
                }

                updateState({
                    newTapMedDrugListData: state.newTapMedDrugListData,
                    isNewTapEdit: false,
                    newTapMedDate: nextDate,
                    newTapMedUnit: +state.newTapMedReduceBy < +state.newTapMedUnit ? (+state.newTapMedUnit) - (+state.newTapMedReduceBy) : state.newTapMedUnit,
                    newTapMedFrequency: frequency + "",
                    newTapMedSelectedIndex: null,
                    dupTapMedDetails: '{}',
                    newTapMedExeUnitType: state.newTapMedExeUnitType ? state.newTapMedExeUnitType : 'mg'
                })
            } else {
                errorMessage(chekNewTap)
            }
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const newCheckTapValidation = (tapperDetails) => {
        try {
            let message = null;
            let steroid = (state.newTapMedGenList?.dosage_type)?.toUpperCase() === "STEROID TABLETS" ? true : false
            if (state.newTapMedDuration === '') {
                message = 'Enter Duration'
            } else if (state.newTapMedUnit === '') {
                message = 'Enter Unit'
            } else if (state.selectedTabCount === '') {
                message = 'select Tablet Count'
            } else if (!state.selMor && !state.selAft && !state.selEve && !state.selNig) {
                message = 'Select M-A-E-N Time'
            } else if (state.newTapMedQty === '') {
                message = 'Enter Quantity'
            } else if (state.newTapMedUsage === '') {
                message = 'Select Usage'
            } else if (state.newTapMedDrugListData?.length > 0) {
                state.newTapMedDrugListData?.forEach((element, index) => {
                    if (state.newTapMedSelectedIndex !== index) {
                        if (element?.start_date === tapperDetails?.start_date && element?.end_date === tapperDetails?.end_date) {
                            message = 'Taper Details Already Exists'
                        }
                    }
                })
            }

            return message;
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const onNewTapEditHandler = (item, index) => {
        try {
            updateState({
                isNewTapEdit: true,
                newTapMedDate: item?.start_date,
                newTapMedDuration: item?.duration1,
                newTapDurationType: item?.durationType,
                newTapMedUnit: item?.unit,
                newTapMedSelectedIndex: index,
                newTapMedReduceBy: item?.reducedBy,
                newTapMedUsage: item?.usage,
                newTapMedQty: item?.quantity,
                selMor: item?.selMor,
                selAft: item?.selAft,
                selEve: item?.selEve,
                selNig: item?.selNig,
                tapMorning: item?.morning,
                tapAfternoon: item?.afternoon,
                tapEvening: item?.evening,
                tapNight: item?.night,
                selectedTabCount: item?.tablet_count,
                newTapMedExeUnitType: item?.unitType,
                newTapMedFreqTablet: item?.freq
            })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderNewUsagePopup = () => {
        try {
            return (
                <Dialog open={state.openAddNew} >
                    <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography fontSize={'0.9dvw'} fontWeight={600}>Add New Usage</Typography>
                        <Button
                            className='Common_Btn_Min_Width'
                            onClick={() => updateState({ openAddNew: false, prescUsage: null })}
                        >
                            <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1dvw'} width={'1dvw'} />
                        </Button>
                    </DialogTitle>
                    <DialogContent>
                        <TextField
                            size='small'
                            sx={{ width: '20dvw', mr: '1dvw' }}
                            value={state.prescUsage}
                            onChange={(e) => {
                                if (e.target.value?.length <= 50) {
                                    updateState({ prescUsage: e.target.value })
                                } else {
                                    errorMessage('Allowed Only 50 Characters')
                                }
                            }}
                            placeholder='Enter Usage'
                        />
                        <Button variant='contained' sx={{ textTransform: 'capitalize' }}
                            disabled={state.postUsageLoad}
                            onClick={postPresctiptionUsageList}
                        >Add</Button>
                    </DialogContent>
                </Dialog>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderNewDosageFormPopup = () => {
        try {
            return (
                <Dialog open={state.openAddNewDosForm} >
                    <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography fontSize={'0.9dvw'} fontWeight={600}>Add New Dosage form Usage</Typography>
                        <Button
                            className='Common_Btn_Min_Width'
                            onClick={() => updateState({ openAddNewDosForm: false, prescDosageForm: null })}
                        >
                            <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1dvw'} width={'1dvw'} />
                        </Button>
                    </DialogTitle>
                    <DialogContent>
                        <TextField
                            size='small'
                            sx={{ width: '20dvw', mr: '1dvw' }}
                            value={state.prescDosageForm}
                            inputProps={{ maxLength: 25 }}
                            onChange={(e) => {
                                updateState({ prescDosageForm: e.target.value })
                            }}
                            placeholder='Enter Dosage Form'
                        />
                        <Button variant='contained' sx={{ textTransform: 'capitalize' }}
                            disabled={state.postFormLoad}
                            onClick={() => postPresDosageFormList()}
                        >Add</Button>
                    </DialogContent>
                </Dialog>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const isTabletOrCapsule = (type) => type === 'Tablet' || type === 'Capsule';

    const calcDuration = (durationMode, duration, item = {}) => {
        const isApplicableDosage =
            (!state.ExternalDrugAdd && isTabletOrCapsule(state.dosageType)) ||
            (state.ExternalDrugAdd && isTabletOrCapsule(state.ExternalDosageType));

        if (durationMode && duration && (!state.checkMl || state.selectedDosageForm !== "ML") && isApplicableDosage) {
            try {
                let qty = 0;
                if (Object.keys(item)?.length > 0) {
                    qty = Math.round(item.morning || 0) + Math.round(item.afternoon || 0) + Math.round(item.evening || 0) + Math.round(item.night || 0);
                } else {
                    qty = Math.round(state.morningQty || 0) + Math.round(state.afternoonQty || 0) + Math.round(state.eveningQty || 0) + Math.round(state.nightQty || 0);
                }

                let calcQty = 0;
                switch (durationMode) {
                    case '1':
                        calcQty = +(qty) * +(duration) * 1;
                        break;
                    case '2':
                        if (duration === "Once In a Week") {
                            calcQty = +(qty) * 1;
                        } else if (duration === "Twice In a Week") {
                            calcQty = +(qty) * 2;
                        } else {
                            calcQty = +(qty) * +(duration) * 7;
                        }
                        break;
                    case '3':
                        if (duration === "Once In a Month") {
                            calcQty = +(qty) * 1;
                        } else if (duration === "Twice In a Month") {
                            calcQty = +(qty) * 2;
                        } else {
                            calcQty = +(qty) * +(duration) * 30;
                        }
                        break;
                    case '4':
                        if (duration !== "Chronic") {
                            calcQty = +(qty) * +(duration) * 365;
                        } else {
                            calcQty = 0
                        }
                        break;
                    case '5':
                        calcQty = +(qty) * Math.round(+(duration) / 2);
                        break;
                }
                if (Object.keys(item)?.length > 0) {
                    return calcQty ?? ""
                } else {
                    updateState({
                        presc_quantity: calcQty ?? ""
                    })
                }
            } catch (error) {
                errorMessage(error.message)
            }
        }
    }

    const renderTapperMedTable = () => {
        try {
            return (
                <Table size='small'>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ backgroundColor: Colors.Background, width: '25%' }}>
                                <Typography fontWeight={600} fontSize={'0.8dvw'}>Days</Typography>
                            </TableCell>
                            <TableCell sx={{ backgroundColor: Colors.Background, width: '20%' }}>
                                <Typography fontWeight={600} fontSize={'0.8dvw'}>Unit</Typography>
                            </TableCell>
                            <TableCell sx={{ backgroundColor: Colors.Background, width: '20%' }}>
                                <Typography fontWeight={600} fontSize={'0.8dvw'}>Frequency</Typography>
                            </TableCell>
                            <TableCell sx={{ backgroundColor: Colors.Background, width: '20%' }}>
                                <Typography fontWeight={600} fontSize={'0.8dvw'}>Reduced By</Typography>
                            </TableCell>
                            <TableCell sx={{ backgroundColor: Colors.Background, width: '15%' }}>
                                <Typography fontWeight={600} fontSize={'0.8dvw'}>Action</Typography>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {state.newTapMedDrugListData?.length > 0 ? state.newTapMedDrugListData?.map((item, index) => {
                            return (
                                <TableRow key={index}>
                                    <TableCell>
                                        <Typography fontSize={'0.8dvw'}>{`${formatDate(item?.start_date)} - ${formatDate(item?.end_date)}`}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography fontSize={'0.8dvw'}>{item?.no_of_dosage ? item?.no_of_dosage : '-'}</Typography>
                                        <Typography fontSize={'0.8dvw'}>{item?.instructions ? item?.instructions : ''}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography fontSize={'0.8dvw'}>{`${item?.morning ? item?.morning : '0'} - ${item?.afternoon ? item?.afternoon : '0'} - ${item?.evening ? item?.evening : '0'} - ${item?.night ? item?.night : '0'}`}</Typography>
                                        <Typography fontSize={'0.8dvw'}>{item?.frequency ? item?.frequency : '-'}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography fontSize={'0.8dvw'}>{item?.reducedBy ? item?.reducedBy : '-'}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Box component={'div'} display={'flex'}>
                                            <Button className='Common_Btn_Min_Width'
                                                onClick={() => { onNewTapEditHandler(item, index) }}
                                            >
                                                <Box component={'img'} src={ImagePaths.UserEditOn.default} height={'1.3dvw'} width={'1.3dvw'} />
                                            </Button>
                                            <Button className='Common_Btn_Min_Width' disabled={state.isNewTapEdit}
                                                onClick={() => {
                                                    state.newTapMedDrugListData?.splice(index, 1)
                                                    updateState({ newTapMedDrugListData: state.newTapMedDrugListData })
                                                }}
                                            >
                                                <Box component={'img'} src={ImagePaths.Delete.default} height={'1.3dvw'} width={'1.3dvw'} />
                                            </Button>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            )
                        }) : <TableRow><TableCell align='center' colSpan={6}>No Records To Be Shown</TableCell></TableRow>}
                    </TableBody>
                </Table>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderTaperStep = () => {
        return (
            <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'row' }}>
                <Box sx={{ width: '60%', visibility: state.isCommonEdit ? "hidden" : "visible" }}>
                    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                        <TableContainer sx={{ height: '35vw', overflowY: 'auto' }}>
                            <Table size='small' stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        {[
                                            { label: 'Favourite', width: '2%' },
                                            { label: 'Prescription', width: '31%' },
                                            { label: 'M-A-E-N', width: '28%' },
                                            { label: 'Duration', width: '15%' },
                                            ...(showQty ? [{ label: 'Quantity', width: '15%' }] : []),
                                            { label: 'Comments', width: '20%' },
                                            { label: 'Action', width: '5%' },
                                        ].map((col) => (
                                            <TableCell
                                                key={col.label}
                                                width={col.width}
                                                sx={{
                                                    fontWeight: 600,
                                                    fontSize: '0.9vw',
                                                    color: Colors.SecondaryText,
                                                    backgroundColor: Colors.Background,
                                                }}
                                            >
                                                {col.label}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        state.tapperList?.length > 0 ? state.tapperList?.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell>
                                                    <Box component={'div'}>
                                                        <Button sx={{ justifyContent: 'flex-start', paddingTop: '0.5vw', }}
                                                            className='Common_Btn_Min_Width'
                                                            disabled={props.isLocked || state.transmitted}
                                                            onClick={() => {
                                                                const updatedtapperList = [...state.tapperList];
                                                                updatedtapperList[index] = {
                                                                    ...updatedtapperList[index],
                                                                    is_favorite: !updatedtapperList[index].is_favorite,
                                                                };

                                                                updateState({
                                                                    tapperList: updatedtapperList,
                                                                    selectedPharmacy: updatedtapperList.length > 0 && updatedtapperList[0]?.pharmacy_id
                                                                        ? updatedtapperList[0].pharmacy_id
                                                                        : "",
                                                                });
                                                            }}>
                                                            <Box component={'img'} src={item?.is_favorite ? ImagePaths.StarFill.default : ImagePaths.StarUnfill.default} height={'1.5vw'} width={'1.5vw'} />

                                                        </Button>
                                                    </Box>
                                                </TableCell>
                                                <TableCell>{item?.drug_name ?
                                                    <Box component={'div'}>
                                                        <Typography fontSize={'0.9vw'} fontWeight={600}>
                                                            {item?.drug_name?.length > 15 ? (
                                                                <Tooltip placement='top' title={item?.drug_name}>
                                                                    <div>{item?.drug_name?.slice(0, 15) + '...'}</div>
                                                                </Tooltip>
                                                            ) : (
                                                                item?.drug_name
                                                            )}
                                                        </Typography>
                                                        <Typography display={"inline-flex"} fontSize={'0.8vw'} color={Colors.SecondaryText}>
                                                            {item?.generic_name ? (
                                                                item.generic_name.length > 15 ? (
                                                                    <Tooltip placement='top' title={item.generic_name}>
                                                                        <div>{item.generic_name.slice(0, 15) + '...'}</div>
                                                                    </Tooltip>
                                                                ) : (
                                                                    item.generic_name
                                                                )
                                                            ) : (
                                                                '-'
                                                            )} | {item?.drug_strength ? item.drug_strength : '-'} {item?.dosage_type || ''}
                                                        </Typography>
                                                    </Box> : '-'}</TableCell>
                                                {/* Tapper Med Table Column Starts ========> */}
                                                {item?.tapper_meds?.length > 0 ?
                                                    <TableCell>
                                                        {item?.tapper_meds?.map((tapList, tapIndex) => {
                                                            let date = formatDate(tapList?.start_date) + "-" + formatDate(tapList?.end_date)
                                                            let mean = tapList?.morning + " - " + tapList?.afternoon + " - " + tapList?.evening + " - " + tapList?.night
                                                            return (
                                                                <Box component={'div'} key={tapIndex} mb={'0.2dvw'}>
                                                                    {mean?.length > 20 ?
                                                                        <Tooltip placement='top' title={mean}><Typography fontSize={'0.8dvw'} fontWeight={600}>{mean?.slice(0, 20) + '...'}</Typography></Tooltip> :
                                                                        <Typography fontSize={'0.8dvw'} fontWeight={600}>{`${tapList?.morning ? tapList?.morning : '0'} - ${tapList?.afternoon ? tapList?.afternoon : '0'} - ${tapList?.evening ? tapList?.evening : '0'} - ${tapList?.night ? tapList?.night : '0'}`}</Typography>}
                                                                    <Typography fontSize={'0.8dvw'}>{instructions(tapList?.instructions)}</Typography>
                                                                    {date?.length > 22 ?
                                                                        <Tooltip placement='top' title={mean}><Typography fontSize={'0.8dvw'} fontWeight={600}>{date?.slice(0, 18) + '...'}</Typography></Tooltip> :
                                                                        <Typography fontSize={'0.8dvw'}>{`${tapList?.start_date ? formatDate(tapList?.start_date) : '-'} - ${tapList?.end_date ? formatDate(tapList?.end_date) : '-'}`}</Typography>
                                                                    }
                                                                </Box>
                                                            )
                                                        })}
                                                    </TableCell> : null}
                                                {item?.tapper_meds?.length > 0 ?
                                                    <TableCell>
                                                        {item?.tapper_meds?.map((tapList, tapIndex) => {
                                                            return (
                                                                <Box component={'div'} key={tapIndex} mb={'0.2dvw'}>
                                                                    <Typography fontSize={'0.8dvw'} visibility={'hidden'}>{'kjsiudok55'}</Typography>
                                                                    <Typography fontSize={'0.8dvw'} fontWeight={600}>{`${tapList?.duration ? tapList?.duration : '-'}`}</Typography>
                                                                    {tapList?.no_of_dosage ? tapList?.no_of_dosage?.length > 10 ?
                                                                        <Tooltip placement='top' title={tapList?.no_of_dosage}><Typography fontSize={'0.8dvw'}>{tapList?.no_of_dosage?.slice(0, 10) + '...'}</Typography></Tooltip> :
                                                                        <Typography fontSize={'0.8dvw'}>{tapList?.no_of_dosage}</Typography> : '-'}
                                                                </Box>
                                                            )
                                                        })}
                                                    </TableCell> : null}
                                                {showQty && item?.tapper_meds?.length > 0 &&
                                                    <TableCell width={'20%'} sx={{ fontSize: '0.9vw', fontWeight: 600 }}>
                                                        {item?.tapper_meds?.map((tapList, tapIndex) => {
                                                            return (
                                                                <Box component={'div'} key={tapIndex} mb={'0.2dvw'}>
                                                                    <Typography fontSize={'0.8dvw'} visibility={'hidden'}>{'kjsiudok55'}</Typography>
                                                                    <Typography fontSize={'0.8dvw'} fontWeight={600}>{(tapList?.quantity ?? 0)}</Typography>
                                                                    <Typography fontSize={'0.8dvw'} visibility={'hidden'}>{'kjsiudok55'}</Typography>
                                                                </Box>
                                                            )
                                                        })}
                                                    </TableCell>}
                                                {/* Tapper Med Table Column End ========> */}
                                                <TableCell sx={{ fontSize: '0.9vw', fontWeight: 600 }}>{item?.comments ? item?.comments?.length > 10 ?
                                                    <Tooltip placement='top' title={item?.comments}><div>{item?.comments?.slice(0, 10) + '...'}</div></Tooltip> :
                                                    item?.comments : '-'}</TableCell>
                                                <TableCell >
                                                    <Box sx={{ fontSize: '0.9vw', fontWeight: 600, display: 'flex' }}>
                                                        <CommonEditButton size={"1.5vw"} disable={props.isLocked || state.transmitted} onClick={onTapperEditHandler.bind(this, item, index)} />
                                                        <CommonDeleteButton size={"1.5vw"} disable={props.isLocked || state.SelectedEditIndex !== null || state.transmitted} onClick={onDeleteHandler.bind(this, item, index, "fromTapper")} />
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        )) : <TableRow>
                                            <TableCell colSpan={headers.length} align="center">
                                                No Records To Be Shown
                                            </TableCell>
                                        </TableRow>
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Box>
                <Box sx={{ width: '40%', overflowY: "auto" }} p={'0.5vw'}>
                    <Typography style={{ paddingLeft: "0.5dvw" }} fontWeight={600} color={Colors.SecondaryText}>Taper Med</Typography>
                    <Box marginTop={'1vw'} display={'flex'} alignItems={'center'} justifyContent={'space-between'} p={'.5vw'}>
                        {renderPharmaSlct(disablePharma)}
                        {state.is_pharmacy ? null : <Button variant='outlined'
                            sx={{ height: '2.5dvw' }}
                            onClick={() => updateState({ tapperExternal: !state.tapperExternal, newTapMedExeUnitType: 'mg' })}
                        >{state.tapperExternal ? 'pharmacy Drug' : 'External Drug'}</Button>}
                    </Box>
                    <Box component={'div'} borderBottom={'1.5px solid lightgray'}>
                        <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} ml={'0.5dvw'}>
                            {state.tapperExternal ?
                                <Autocomplete
                                    clearIcon
                                    size='small'
                                    sx={{ width: "20dvw", mt: '0.25dvw', mb: '0.5dvw' }}
                                    freeSolo
                                    options={state.newTapMedExeDrugList}
                                    getOptionLabel={(option) => typeof (option) === 'string' ? option : option.drug_name}
                                    value={state.newTapExeSearchDrug}
                                    onChange={(e, value) => {
                                        updateState({ newTapExeSearchDrug: value })
                                    }}
                                    renderInput={(params) => <TextField {...params} label='Search External Drug'
                                        onChange={(e) => {
                                            let value = e.target.value
                                            updateState({ tempSearch: value, newTapExeSearchDrug: value })
                                        }} />}
                                /> : <Autocomplete
                                    clearIcon
                                    size='small'
                                    sx={{ width: "20dvw", mt: '0.25dvw' }}
                                    options={state.TapperDrugList}
                                    getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.drug_name}
                                    value={state.newTapSearchDrug}
                                    onChange={(e, value) => {
                                        updateState({ newTapSearchDrug: value })
                                        if (!value) {
                                            onClearTapMedHandler()
                                        }
                                    }}
                                    renderInput={(params) => <TextField
                                        {...params}
                                        label='Search Drug'
                                        onChange={(e) => { handleInputChange(e.target.value) }}
                                    />}
                                />}
                        </Box>
                        {state.tapperExternal ? null : <Box component={'div'} mt={'0.5dvw'} mb={'0.5dvw'}>
                            {state.MedicationFav?.length > 0 ? state.MedicationFav?.map((item, index) => {
                                return (
                                    <Chip
                                        className={`eMed_chip ${(item.drug_name ? (item?.drug_ms_id === state.selectedDrugIdTap && (item.drug_name) === state.tapSelectedDrug) : (item === state.tapSelectedDrug)) ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                                        size="small"
                                        label={item?.drug_name}
                                        key={index}
                                        onClick={() => {
                                            if (state.tapSelectedDrug === item?.drug_name) {
                                                onClearTapMedHandler()
                                            } else {
                                                updateState({
                                                    selectedDrugIdTap: item?.drug_ms_id,
                                                    tapSelectedDrug: item?.drug_name,
                                                    newTapSearchDrug: null,
                                                    TapperDrugList: []
                                                })
                                            }
                                        }}
                                        variant={(item.drug_name ? (item?.drug_ms_id === state.selectedDrugIdTap && (item.drug_name) === state.tapSelectedDrug) : (item === state.tapSelectedDrug)) ? 'contained' : 'outlined'}
                                        clickable
                                    />
                                )
                            }) : null}
                        </Box>}
                    </Box>
                    {state.tapperExternal ? null : (state.newTapMedGenList && Object.keys(state.newTapMedGenList).length > 0) ?
                        <Box component={'div'} borderBottom={'1.5px solid lightgray'} mt={'0.5dvw'}>
                            <Typography fontSize={'0.9dvw'} fontWeight={600} color={Colors.SecondaryText}>Drug Details</Typography>
                            <Box component={'div'} display={'flex'} alignItems={'center'} m={'0.5vw'}>
                                <Box component={'img'} src={ImagePaths.Tablet.default} height={'1.5vw'} width={'1.5vw'} />
                                <Box component={'div'} ml={'1dvw'}>
                                    <Typography>{state.newTapMedGenList?.drug_name ? state.newTapMedGenList?.drug_name : state.newTapMedGenList?.brand_name}</Typography>
                                    <Typography>{`${state.newTapMedGenList?.generic_name} | ${state.newTapMedGenList?.dosage_type}`}</Typography>
                                    {state.stock_in_quantity ? <Typography fontSize={"1dvw"}>{`Available quantity: ${state.stock_in_quantity}`}</Typography> : null}
                                </Box>
                                <Box component={'div'} ml={'1dvw'}>
                                    <Typography>{state.newTapMedGenList?.dosage_strength}</Typography>
                                    <Typography>Strength</Typography>
                                </Box>
                                <Box component={'div'} ml={'1dvw'}>
                                    <Button className='Common_Btn_Min_Width'
                                        onClick={() => {
                                            updateState({
                                                newTapMedGenList:
                                                    { ...state?.newTapMedGenList, is_favorite: !state?.newTapMedGenList?.is_favorite }
                                            })
                                        }}>
                                        <Box component={'img'}
                                            src={state?.newTapMedGenList?.is_favorite ? ImagePaths.StarFill.default
                                                : ImagePaths.StarUnfill.default} height={'1.5vw'} width={'1.5vw'} />
                                    </Button>
                                </Box>
                            </Box>
                        </Box> : null}
                    {state.tapperExternal ?
                        <Box component={'div'} mt={'0.5dvw'} mb={'0.5dvw'}>
                            <TextField size='small' label={'Generic Name'} sx={{ mr: '0.5dvw', mb: '1dvw' }}
                                value={state.newTapMedExeGenericName}
                                onChange={(e) => updateState({ newTapMedExeGenericName: e.target.value })} />
                            <TextField size='small' label={'Dosage Strength'}
                                value={state.newTapMedExeDosageStrength}
                                onChange={(e) => {
                                    if (CommonValidation.numberOnly(e.target.value) && +e.target.value <= 5000 || e.target.value === '') {
                                        const { value } = e.target;
                                        const unit = value ? value?.match(/\d+/) : value

                                        updateState({
                                            newTapMedExeDosageStrength: value,
                                            newTapMedUnit: unit
                                        })
                                    }
                                }} />
                            <TextField size='small' label={'Dosage Type'}
                                value={state.newTapMedExeDosageType}
                                onChange={(e) => {
                                    updateState({ newTapMedExeDosageType: e.target.value })
                                }} />
                        </Box>
                        : null}
                    <Box m={'0.5dvw 0dvw'}><Typography fontSize={'0.9dvw'} fontWeight={600}>Taper Details</Typography></Box>
                    <Box component={'div'} mt={'0.5dvw'}>
                        <Typography fontSize={'0.9dvw'} fontWeight={600} color={Colors.SecondaryText}>Tablet Count *</Typography>
                        <Box component={'div'}>
                            {Number_Count?.map((item, index) => {
                                return (
                                    <Chip
                                        disabled={state.tapperExternal ? false : Object.keys(state.newTapMedGenList)?.length === 0 ? true : false}
                                        className='eMed_chip'
                                        label={item}
                                        key={index}
                                        onClick={() => {
                                            updateState({
                                                selectedTabCount: item,
                                                tapMorning: state.selMor ? item : '',
                                                tapAfternoon: state.selAft ? item : '',
                                                tapEvening: state.selEve ? item : '',
                                                tapNight: state.selNig ? item : ''
                                            })
                                        }}
                                        variant={item !== state.selectedTabCount ? 'outlined' : 'contained'}
                                        color={'primary'}
                                        clickable
                                    />
                                )
                            })}
                            <TextField
                                disabled={state.tapperExternal ? false : Object.keys(state.newTapMedGenList)?.length === 0 ? true : false}
                                autoComplete='off'
                                size='small'
                                value={state.selectedTabCount}
                                sx={{ width: '5dvw' }}
                                onChange={(e) => {
                                    let value = e.target.value
                                    if (CommonValidation.DecimalNumberTwo(value) || value == '') {
                                        updateState({
                                            selectedTabCount: value,
                                            tapMorning: state.selMor ? value : '',
                                            tapAfternoon: state.selAft ? value : '',
                                            tapEvening: state.selEve ? value : '',
                                            tapNight: state.selNig ? value : ''
                                        })
                                    }
                                }}
                            />
                        </Box>
                        <Box component={'div'} mt={'0.5dvw'}>
                            <Typography fontSize={'0.9dvw'} fontWeight={600} color={Colors.SecondaryText}>M-A-E-N *</Typography>
                            <Box component={'div'} mt={'0.5dvw'} mb={'0.5dvw'}>
                                <Button
                                    disabled={((state.selectedTabCount === '')) ? true : false}
                                    variant={state.selMor ? 'contained' : 'outlined'} sx={{ width: '6dvw', mr: "0.5dvw", textTransform: 'capitalize' }}
                                    onClick={() => {
                                        const toggledSelMor = !state.selMor;
                                        updateState({
                                            selMor: toggledSelMor,
                                            tapMorning: toggledSelMor ? state.selectedTabCount : '',
                                            tapAfternoon: (toggledSelMor && state.selAft) ? state.selectedTabCount : '',
                                            tapEvening: (toggledSelMor && state.selEve) ? state.selectedTabCount : '',
                                            tapNight: (toggledSelMor && state.selNig) ? state.selectedTabCount : ''
                                        })
                                    }}>Morning</Button>
                                <Button
                                    disabled={((state.selectedTabCount === '')) ? true : false}
                                    variant={state.selAft ? 'contained' : 'outlined'} sx={{ width: '6dvw', mr: "0.5dvw", textTransform: 'capitalize' }}
                                    onClick={() => {
                                        const toggledSelAft = !state.selAft;
                                        updateState({
                                            selAft: toggledSelAft,
                                            tapMorning: (toggledSelAft && state.selMor) ? state.selectedTabCount : '',
                                            tapAfternoon: toggledSelAft ? state.selectedTabCount : '',
                                            tapEvening: (toggledSelAft && state.selEve) ? state.selectedTabCount : '',
                                            tapNight: (toggledSelAft && state.selNig) ? state.selectedTabCount : ''
                                        })
                                    }}>Afternoon</Button>
                                <Button
                                    disabled={((state.selectedTabCount === '')) ? true : false}
                                    variant={state.selEve ? 'contained' : 'outlined'} sx={{ width: '6dvw', mr: "0.5dvw", textTransform: 'capitalize' }}
                                    onClick={() => {
                                        const toggledSelEve = !state.selEve;
                                        updateState({
                                            selEve: toggledSelEve,
                                            tapMorning: (toggledSelEve && state.selMor) ? state.selectedTabCount : '',
                                            tapAfternoon: (toggledSelEve && state.selAft) ? state.selectedTabCount : '',
                                            tapEvening: (toggledSelEve) ? state.selectedTabCount : '',
                                            tapNight: (toggledSelEve && state.selNig) ? state.selectedTabCount : ''
                                        })
                                    }}>Evening</Button>
                                <Button
                                    disabled={((state.selectedTabCount === '')) ? true : false}
                                    variant={state.selNig ? 'contained' : 'outlined'} sx={{ width: '6dvw', textTransform: 'capitalize' }}
                                    onClick={() => {
                                        const toggledSelNig = !state.selNig;
                                        updateState({
                                            selNig: toggledSelNig,
                                            tapMorning: (toggledSelNig && state.selMor) ? state.selectedTabCount : '',
                                            tapAfternoon: (toggledSelNig && state.selAft) ? state.selectedTabCount : '',
                                            tapEvening: (toggledSelNig && state.selEve) ? state.selectedTabCount : '',
                                            tapNight: (toggledSelNig) ? state.selectedTabCount : ''
                                        })
                                    }}>Night</Button>
                            </Box>
                            <Box component={'div'} mt={'1dvw'} display={'flex'}>
                                <Box component={'div'} display={'flex'}>
                                    <Box component={'div'} mr={'1dvw'}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                open={state.newTapMedOpenDate}
                                                onOpen={() => { updateState({ newTapMedOpenDate: true }) }}
                                                onClose={() => { updateState({ newTapMedOpenDate: false }) }}
                                                value={state.newTapMedDate}
                                                inputFormat='DD-MM-YYYY'
                                                label={"Select Date"}
                                                disabled={state.tapperExternal ? false : Object.keys(state.newTapMedGenList)?.length === 0 ? true : false}
                                                minDate={new Date()}
                                                onChange={(value) => { updateState({ newTapMedDate: value }) }}
                                                renderInput={(params) => <TextField size='small' {...params}
                                                    sx={{ width: '14dvw' }}
                                                    onKeyDown={(e) => e.preventDefault()}
                                                    onClick={() => { updateState({ newTapMedOpenDate: true }) }}
                                                />}
                                            />
                                        </LocalizationProvider>
                                    </Box>
                                    <TextField
                                        disabled={state.tapperExternal ? false : Object.keys(state.newTapMedGenList)?.length === 0 ? true : false}
                                        autoComplete='off'
                                        sx={{ width: '8dvw' }}
                                        size='small'
                                        value={state.newTapMedDuration}
                                        onChange={(e) => {
                                            let value = e.target.value
                                            if (CommonValidation.numberOnly(value) || value === '') {
                                                updateState({ newTapMedDuration: value })
                                            }
                                        }}
                                        label={'Duration *'}
                                    />
                                    <Select
                                        disabled={state.tapperExternal ? false : Object.keys(state.newTapMedGenList)?.length === 0 ? true : false}
                                        size='small'
                                        sx={{ width: '7vw' }}
                                        value={state.newTapDurationType}
                                        onChange={(e) => updateState({ newTapDurationType: e.target.value, tapDuration: '' })}
                                    >
                                        <MenuItem value="Day(s)">Days</MenuItem>
                                        <MenuItem value="Week(s)">Weeks</MenuItem>
                                        <MenuItem value="Month(s)">Months</MenuItem>
                                    </Select>
                                </Box>
                            </Box>
                            <Box component={'div'} display={'flex'} mt={'1dvw'}>
                                <Box component={'div'} mr={'1dvw'}>
                                    <TextField
                                        autoComplete='off'
                                        sx={{ width: '8dvw' }}
                                        size='small'
                                        value={state.newTapMedUnit}
                                        onChange={(e) => {
                                            let value = e.target.value
                                            if (CommonValidation.numberOnly(value) || value === '') {
                                                updateState({ newTapMedUnit: value })
                                            }
                                        }}
                                        label={'Unit *'}
                                    />
                                    <FormControl size='small' sx={{ width: '7vw' }}>
                                        <Select
                                            disabled={state.newTapMedDrugListData?.length === 0 ? false : true}
                                            value={state.newTapMedExeUnitType}
                                            onChange={(e) => {
                                                updateState({ newTapMedExeUnitType: e.target.value })
                                            }}
                                        >
                                            {UNIT_LIST?.map((item, index) => {
                                                return (
                                                    <MenuItem key={index} value={item}>{item}</MenuItem>
                                                )
                                            })}
                                        </Select>
                                    </FormControl>
                                </Box>
                                <TextField
                                    autoComplete='off'
                                    size='small'
                                    sx={{ width: '14dvw' }}
                                    value={state.newTapMedReduceBy}
                                    onChange={(e) => {
                                        if (CommonValidation.numberOnly(e.target.value) || e.target.value === '') {
                                            updateState({ newTapMedReduceBy: e.target.value })
                                        }
                                    }}
                                    label='Reduce By'
                                />
                            </Box>
                            <Box component={'div'} mt={'1dvw'} display={'flex'}>
                                <Autocomplete
                                    size='small'
                                    sx={{ width: '15vw', mr: "1vw" }}
                                    clearIcon
                                    freeSolo
                                    options={state.frequency_list}
                                    getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.frequency_name}
                                    value={state.newTapMedFreqTablet}
                                    onChange={(e, value) => {
                                        updateState({ newTapMedFreqTablet: value })
                                    }}
                                    renderInput={(params) => <TextField {...params}
                                        value={state.newTapMedFreqTablet}
                                        onChange={(e) => {
                                            updateState({ newTapMedFreqTablet: e.target.value })
                                        }}
                                        inputProps={{ ...params.inputProps, maxLength: 50 }}
                                        label='Frequency' />}
                                />
                                <TextField
                                    disabled={state.tapperExternal ? false : Object.keys(state.newTapMedGenList)?.length === 0 ? true : false}
                                    autoComplete='off'
                                    sx={{ width: '14dvw' }}
                                    size='small'
                                    value={state.newTapMedQty}
                                    onChange={(e) => {
                                        let value = e.target.value
                                        if (CommonValidation.numberOnly(value) || value === '') {
                                            updateState({ newTapMedQty: value })
                                        }
                                    }}
                                    label={'Quantity *'}
                                />
                            </Box>
                            <Box component={'div'} mt={'0.8dvw'} display={'flex'}>
                                <Autocomplete
                                    clearIcon
                                    size='small'
                                    sx={{ width: '11vw' }}
                                    options={state.prescriptionUsage}
                                    getOptionLabel={(option) => typeof (option) === 'string' ? getOptions(option) : option.label}
                                    value={state.newTapMedUsage}
                                    onChange={(e, value) => updateState({ newTapMedUsage: value?.label })}
                                    renderInput={(params) => <TextField {...params} label={'Select Usage *'} />}
                                    renderOption={(props, item) => {
                                        return (
                                            <Box component={'div'} display={'flex'} justifyContent={'space-between'} key={props["data-option-index"]}>
                                                <Box component="li" {...props} width={'100%'}>
                                                    <Typography>{item?.label}</Typography>
                                                </Box>
                                                {item?.is_added ?
                                                    <Button className='Common_Btn_Min_Width'
                                                        onClick={() => deletePresctiptionUsageList(item)}
                                                    ><DeleteIcon color='error' /></Button> : null}
                                            </Box>
                                        )
                                    }}
                                    PaperComponent={({ children }) => {
                                        return (
                                            <Paper>
                                                {children}
                                                <Divider />
                                                <Button
                                                    color="primary"
                                                    fullWidth
                                                    sx={{ justifyContent: "flex-start", pl: 2, textTransform: 'capitalize' }}
                                                    onMouseDown={(e) => {
                                                        updateState({ openAddNew: true })
                                                    }}
                                                >
                                                    Add Usage
                                                </Button>
                                            </Paper>
                                        )
                                    }}
                                />
                                <TextField
                                    autoComplete='off'
                                    sx={{ width: '13dvw', marginLeft: '1vw' }}
                                    size='small'
                                    value={state.newTapMedComments}
                                    onChange={(e) => {
                                        if (e.target.value?.length <= 100) {
                                            updateState({ newTapMedComments: e.target.value })
                                        } else {
                                            errorMessage('Allow only 100 characters')
                                        }
                                    }}
                                    label={'Comments'}
                                />
                                <Button variant='contained' sx={{ ml: '0.5dvw', textTransform: 'capitalize' }}
                                    onClick={() => onNewTappperMedAddHandler()}
                                >Add</Button>
                            </Box>
                        </Box>
                    </Box>
                    <Box component={'div'} border={'1px solid lightgray'} mt={'0.5dvw'}>
                        {renderTapperMedTable()}
                    </Box>
                    <Stack spacing={2} direction="row" sx={{ backgroundColor: Colors.DataTblHeaderbg, visibility: state.isCommonEdit ? "hidden" : "visible" }} alignItems="center" justifyContent="center" height={"5.5dvh"}>
                        <Button variant='outlined' size="small" id="eMed_Config_btn" onClick={() => { onClearTapMedHandler(true) }}>{("Clear")}</Button>
                        <Button variant='contained' size="small" id="eMed_Config_btn" onClick={() => { drugValidation("tapperMed") }}>{("Add")}</Button>
                    </Stack>
                </Box>
            </Box>
        )
    }

    const disableBtn = useMemo(() => {
        return state.isLocked || props.isLocked || state.transmitted
    }, [state.isLocked, props.isLocked, state.transmitted]);

    useImperativeHandle(ref, () => ({
        getPrescriptionListData
    }));
    const headerList = [...headers];
    if (showQty) {
         headerList.splice(4, 0, 'Quantity');
    }

    // render
    return (
        <ShowComponents onIntersection={getApiCall.bind(this)}>
            <Card sx={{
                width: "100%", height: "fit-content", padding: "0.3vw",
                marginBottom: "0.5vw", border: `2px solid ${props.isSelected ? Colors.themeDark : Colors.white}`
            }}>
                <Box display={"flex"} flexDirection={'row'} alignItems={"center"} justifyContent={'space-between'} padding={"0.5vw"} borderBottom={`1px solid #E3E2E2`}>
                    <Box display={"flex"} flexDirection={'row'} alignItems={"center"} columnGap={"0.5vw"}>
                        {renderTitle(Title, props.isSelected)}
                        {is_save_transmit ? null : !state.is_pharmacy && renderIconButton('Transmit', (disableBtn || state.isTransClked) ? ImagePaths.medicationTransmitOff.default : ImagePaths.medicationTransmitOn.default, () => handleTransmit(), disableBtn)}
                        {renderIconButton('Previous Prescription', ImagePaths.PreviousPrescription.default, () => getPreviousPrescriptionData(), disableBtn)}
                        {renderIconButton('Favourite', ImagePaths.StarUnfill.default, () => { updateState({ openFav: true }) }, disableBtn)}
                        {(state.Recalled === false && state.transmitted && !props.isLocked) ?
                            <Button
                                className='Common_Btn_Min_Width'
                                onClick={() => { updateState({ recallPopup: true }) }}
                            >
                                <Tooltip placement='top' title='Recall' arrow>
                                    <div style={{ backgroundColor: "#b8170d", borderRadius: "0.2vw" }}>
                                        <Box component={'img'} src={ImagePaths.Recall.default} height={'1.7vw'} width={'1.7vw'} />
                                    </div>
                                </Tooltip>
                            </Button>
                            : null}
                    </Box>
                    <Box display={"flex"} flexDirection={'row'} alignItems={"center"} columnGap={"0.625vw"}>
                        <Autocomplete
                            size='small'
                            disabled={disableBtn}
                            sx={{ width: '13vw' }}
                            options={state.prescriptionTemplateList}
                            getOptionLabel={(option) => option.template_name || ''}
                            value={state.selectedTemplate}
                            autoComplete='off'
                            onChange={(event, newValue) => {
                                updateState({
                                    selectedTemplate: newValue,
                                    isEditDuration: false
                                })
                            }}
                            renderOption={(props, option) => {
                                return (
                                    <li {...props} style={{ padding: "0vh 1.2vh" }}>
                                        <ListItem sx={{ display: 'flex', justifyContent: 'space-between', padding: 0 }}>
                                            <ListItemText primary={option?.template_name && option?.template_name?.length > 14 ?
                                                <Tooltip placement='top' title={option?.template_name}>
                                                    {<div>{option?.template_name?.slice(0, 14) + '...'}</div>}
                                                </Tooltip> : option?.template_name} />
                                            <IconButton
                                                edge="end"
                                                color="error"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    updateState({
                                                        tempType: 'delete',
                                                        deleteTemplateName: option,
                                                        deletePopup: true
                                                    });
                                                }}
                                            >
                                                <Tooltip placement='top' title={"Delete"} arrow>
                                                    <DeleteIcon sx={{ height: "2.5vh", width: "2.5vw" }} /> </Tooltip>
                                            </IconButton>
                                        </ListItem>
                                    </li>
                                );
                            }}
                            renderInput={(params) => <TextField {...params} label='Select Template' />}
                            PaperComponent={({ children }) => {
                                return (
                                    <Paper component={'div'}>
                                        {children}
                                        <Button
                                            color="primary"
                                            fullWidth
                                            sx={{ justifyContent: "flex-start", pl: 2, textTransform: 'capitalize' }}
                                            onMouseDown={(e) => {
                                                updateState({ openPopupAddNew: true, tempType: 'Add' })
                                            }}
                                        >
                                            Save as Template
                                        </Button>
                                    </Paper>
                                )
                            }}
                        />
                        <Select
                            size='small'
                            sx={{ width: '10vw' }}
                            value={state.selectedLanguage}
                            onChange={(e) => updateState({ selectedLanguage: e.target.value })}
                        >
                            {state.languageList?.map((item, index) => (
                                <MenuItem value={item?.value} key={index}>{item?.label}</MenuItem>
                            ))}
                        </Select>
                        {renderIconButton('Print', ImagePaths.PrintIcons.default, () => getPrescriptionPrint(), false, "2vw")}
                        <Button size='small' variant='contained' sx={{ textTransform: 'capitalize' }}
                            disabled={disableBtn}
                            onClick={() => { updateState({ openPrescripton: true }) }}>Add</Button>
                    </Box>
                </Box>
                <Box>
                    <Table size='small' stickyHeader aria-label="sticky table" sx={{ maxHeight: '20vw', overflowY: 'auto' }}>
                        <TableHead>
                            <TableRow>
                                {headerList?.map((text, idx) => (
                                    <TableCell
                                        key={idx}
                                        sx={{
                                            fontWeight: 600,
                                            fontSize: '0.9vw',
                                            color: Colors.SecondaryText,
                                            backgroundColor: Colors.Background,
                                        }}
                                    >
                                        {text}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {state.prescriptionData?.length > 0 ? state.prescriptionData?.map((item, index) => {
                                const showMl = (item?.is_unit_ml || item?.dosage_unit === "ML") ? "ML" : ""
                                return (
                                <TableRow key={index}>
                                    <TableCell>
                                        <Box component={'div'}>
                                            <Button sx={{ justifyContent: 'flex-start', paddingTop: '0.5vw', }}
                                                className='Common_Btn_Min_Width'
                                                disabled={props.isLocked || state.transmitted}
                                            >
                                                <Box component={'img'} src={item?.is_favorite ? ImagePaths.StarFill.default : ImagePaths.StarUnfill.default} height={'1.5vw'} width={'1.5vw'} />
                                            </Button>
                                        </Box>
                                    </TableCell>
                                    <TableCell style={{ color: (item?.high_alert || item?.is_high_alert) && state.enable_drug_alert ? 'red' : 'inherit' }}>{item?.drug_name ?
                                        <Box component={'div'}>
                                            <Typography fontSize={'0.9vw'} fontWeight={600}>
                                                {item?.drug_name?.length > 15 ? (
                                                    <Tooltip placement='top' title={item?.drug_name}>
                                                        <div>{item?.drug_name?.slice(0, 15) + '...'}</div>
                                                    </Tooltip>
                                                ) : (
                                                    item?.drug_name
                                                )}
                                            </Typography>
                                            <Typography display={"inline-flex"} fontSize={'0.8vw'} color={Colors.SecondaryText}>
                                                {item?.generic_name ? (
                                                    item.generic_name.length > 15 ? (
                                                        <Tooltip placement='top' title={item.generic_name}>
                                                            <div>{item.generic_name.slice(0, 15) + '...'}</div>
                                                        </Tooltip>
                                                    ) : (
                                                        item.generic_name
                                                    )
                                                ) : (
                                                    '-'
                                                )} | {item?.drug_strength ? item.drug_strength : '-'} {item?.dosage_type || ''}
                                            </Typography>
                                        </Box> : '-'
                                    }</TableCell>
                                    {item?.tapper_meds?.length > 0 ? null :
                                        <><TableCell>
                                            <Box component={'div'}>
                                                <Typography fontSize={showMl ? '0.8vw' : '0.9vw'} fontWeight={600}>{`${item?.morning ? item?.morning : '0'}${showMl} - ${item?.afternoon ? item?.afternoon : '0'}${showMl} - ${item?.evening ? item?.evening : '0'}${showMl} - ${item?.night ? item?.night : '0'}${showMl}`}</Typography>
                                                <Typography fontSize={'0.8vw'} color={Colors.SecondaryText}>{instructions(item?.instructions)}</Typography>
                                            </Box>
                                        </TableCell>

                                            <TableCell sx={{ fontSize: '0.9vw', fontWeight: 600 }}>
                                                {`${item?.duration ? item?.duration :
                                                    item?.duration?.label ? item?.duration?.label : 0}
                                                              ${durationOptions[item?.duration_mode]}`}
                                            </TableCell>
                                            {showQty && <TableCell width={'10%'} sx={{ fontSize: '0.9vw', fontWeight: 600 }}>
                                                 {item?.quantity?.length > 10 ?
                                                <Tooltip placement='top' title={item?.quantity}>
                                                        <Typography fontWeight={600}>{item?.quantity?.slice(0, 10) + '...'}</Typography>
                                                </Tooltip> :
                                                <Typography fontWeight={600}>{item?.quantity ?? 0}</Typography>}</TableCell>}
                                        </>}

                                    {/* Tapper Med Table Column Starts ========> */}
                                    {item?.tapper_meds?.length > 0 ?
                                        <TableCell>
                                            {item?.tapper_meds?.map((tapList, tapIndex) => {
                                                let date = formatDate(tapList?.start_date) + "-" + formatDate(tapList?.end_date)
                                                let mean = tapList?.morning + " - " + tapList?.afternoon + " - " + tapList?.evening + " - " + tapList?.night
                                                return (
                                                    <Box component={'div'} key={tapIndex} mb={'0.2dvw'}>
                                                        {mean?.length > 20 ?
                                                            <Tooltip placement='top' title={mean}><Typography fontSize={'0.8dvw'} fontWeight={600}>{mean?.slice(0, 20) + '...'}</Typography></Tooltip> :
                                                            <Typography fontSize={'0.8dvw'} fontWeight={600}>{`${tapList?.morning ? tapList?.morning : '0'} - ${tapList?.afternoon ? tapList?.afternoon : '0'} - ${tapList?.evening ? tapList?.evening : '0'} - ${tapList?.night ? tapList?.night : '0'}`}</Typography>}
                                                        <Typography fontSize={'0.8dvw'}>{instructions(tapList?.instructions)}</Typography>
                                                        {date?.length > 22 ?
                                                            <Tooltip placement='top' title={mean}><Typography fontSize={'0.8dvw'} fontWeight={600}>{date?.slice(0, 18) + '...'}</Typography></Tooltip> :
                                                            <Typography fontSize={'0.8dvw'}>{`${tapList?.start_date ? formatDate(tapList?.start_date) : '-'} - ${tapList?.end_date ? formatDate(tapList?.end_date) : '-'}`}</Typography>
                                                        }
                                                    </Box>
                                                )
                                            })}
                                        </TableCell> : null}
                                    {item?.tapper_meds?.length > 0 ?
                                        <TableCell>
                                            {item?.tapper_meds?.map((tapList, tapIndex) => {
                                                return (
                                                    <Box component={'div'} key={tapIndex} mb={'0.2dvw'}>
                                                        <Typography fontSize={'0.8dvw'} visibility={'hidden'}>{'kjsiudok55'}</Typography>
                                                        <Typography fontSize={'0.8dvw'} fontWeight={600}>{`${tapList?.duration ? tapList?.duration : '-'}`}</Typography>
                                                        {tapList?.no_of_dosage ? tapList?.no_of_dosage?.length > 10 ?
                                                            <Tooltip placement='top' title={tapList?.no_of_dosage}><Typography fontSize={'0.8dvw'}>{tapList?.no_of_dosage?.slice(0, 10) + '...'}</Typography></Tooltip> :
                                                            <Typography fontSize={'0.8dvw'}>{tapList?.no_of_dosage}</Typography> : '-'}
                                                    </Box>
                                                )
                                            })}
                                        </TableCell> : null}
                                        {showQty && item?.tapper_meds?.length > 0 &&
                                            <TableCell width={'10%'} sx={{ fontSize: '0.9vw', fontWeight: 600 }}>
                                                {item?.tapper_meds?.map((tapList, tapIndex) => {
                                                    return (
                                                        <Box component={'div'} key={tapIndex} mb={'0.2dvw'}>
                                                            <Typography fontSize={'0.8dvw'} visibility={'hidden'}>{'kjsiudok55'}</Typography>
                                                            <Typography fontSize={'0.8dvw'} fontWeight={600}>{(tapList?.quantity ?? 0)}</Typography>
                                                            <Typography fontSize={'0.8dvw'} visibility={'hidden'}>{'kjsiudok55'}</Typography>
                                                        </Box>
                                                    )
                                                })}
                                            </TableCell>}
                                    {/* Tapper Med Table Column Ends ========> */}
                                    <TableCell sx={{ fontSize: '0.9vw', fontWeight: 600 }}>{item?.comments ? item?.comments?.length > 10 ?
                                        <Tooltip placement='top' title={item?.comments}><div>{item?.comments?.slice(0, 10) + '...'}</div></Tooltip> :
                                        item?.comments : '-'}</TableCell>
                                    <TableCell >
                                        <Box sx={{ fontSize: '0.9vw', fontWeight: 600, display: 'flex' }}>
                                            <CommonEditButton size={"1.5vw"} disable={props.isLocked || state.transmitted} onClick={onCommonEditHandler.bind(this, item, index)} />
                                            <CommonDeleteButton size={"1.5vw"} disable={props.isLocked || state.transmitted} onClick={onDeleteHandler.bind(this, item, index, "fromCommon")} />
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            )}) :
                                <TableRow>
                                    <TableCell colSpan={headerList.length} align="center">
                                        No Records To Be Shown
                                    </TableCell>
                                </TableRow>
                            }
                        </TableBody>
                    </Table>
                </Box>
            </Card>
            {renderPrescription()}
            {renderNewUsagePopup()}
            {renderNewDosageFormPopup()}
            {renderPreviousPrescriptionPopup()}
            {renderNewTemplatePopup()}
            {renderFavPopup()}
            {renderRecallPopup()}
            {state.successPopup && renderSuccessPopup()}
            {
                state.deletePopup &&
                <DeletePopup
                    DeletTitle={`Are you sure you want to delete  ${state.deleteTemplateName?.template_name ? state.deleteTemplateName?.template_name : "-"} ?`}
                    deleteAlertPopupClose={closeDeletePopup.bind(this)}
                    removeData={removeDataList.bind(this)}
                    disable={state.removeData}
                />
            }
            {
                allergyPopup ?
                    <ConfirmPopup
                        cnfTitle={'Confirm'}
                        cnfContent={"This generic name is listed in the patient's medication allergies. Are you sure you want to proceed?"}
                        cnfAlertPopupClose={popClose}
                        cnfData={confirmSave}
                        btnText2={"Proceed"}
                    />
                    : null
            }
            {state.highAlert && state.enable_drug_alert && !state.isEdit ?
                <HighAlertDrugPopup
                    selectedDrug={state?.selectedDrug}
                    is_high_alert={state?.is_high_alert}
                    is_lookAlike={state?.is_look_alike}
                    is_soundAlike={state?.is_sound_alike}
                    lookAlikeDrugs={state?.lookAlikeDrugs}
                    soundAlikeDrugs={state?.SoundAlikeDrugs}
                    onCancel={highAlertpopupClose}
                    onConfirm={highAlertpopupConfirm}
                /> : null
            }
        </ShowComponents>
    )
});

export default SarasPrescription;